/**
 * @fileoverview Variable container for variable object
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _simplebar = _interopRequireDefault(require("simplebar"));
var _xssFilters = _interopRequireDefault(require("xss-filters"));
var _CloudVariable = _interopRequireDefault(require("../extensions/CloudVariable"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _VariableContainer_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/**
 * Block variable constructor
 * @param {variable model} variable
 * @constructor
 */
Entry.VariableContainer = (_VariableContainer_brand = /*#__PURE__*/new WeakSet(), /*#__PURE__*/function () {
  function VariableContainer() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, VariableContainer);
    _classPrivateMethodInitSpec(this, _VariableContainer_brand);
    (0, _defineProperty2["default"])(this, "_maxNameLength", 10);
    (0, _defineProperty2["default"])(this, "hasBlockInFunction", (0, _memoize2["default"])(function (blockId) {
      return (0, _some2["default"])(_this.functions_, function (func) {
        return Boolean(func.getBlockById(blockId));
      });
    }));
    (0, _defineProperty2["default"])(this, "hasParamBlockInFunction", (0, _memoize2["default"])(function (paramId) {
      return (0, _some2["default"])(_this.functions_, function (func) {
        return Boolean(func.getBlockByParamId(paramId));
      });
    }));
    (0, _defineProperty2["default"])(this, "hasFuncBlockInFunction", (0, _memoize2["default"])(function (funcId) {
      return (0, _some2["default"])(_this.functions_, function (func) {
        return Boolean(func.getFuncBlockByFuncId("func_".concat(funcId)));
      });
    }));
    this.cloudVariable = _CloudVariable["default"].getInstance();
    this.variables_ = [];
    this.messages_ = [];
    this.lists_ = [];
    this.functions_ = {};
    this.viewMode_ = 'all';
    this.selected = null;
    this.variableAddPanel = {
      isOpen: false,
      info: {
        object: null,
        isCloud: false,
        isRealTime: false
      }
    };
    this.listAddPanel = {
      isOpen: false,
      info: {
        object: null,
        isCloud: false,
        isRealTime: false
      }
    };
    this.messageAddPanel = {
      isOpen: false,
      info: {
        object: null,
        isCloud: false
      }
    };
    this.selectedVariable = null;
    this._variableRefs = [];
    this._messageRefs = [];
    this._functionRefs = [];
    this._filterTabs = {};
    this.listView_ = null;
    Entry.addEventListener('workspaceChangeMode', this.updateList.bind(this));
    Entry.addEventListener('changeFuncVariableListSize', this.updateFuncVariableList.bind(this));
  }
  return (0, _createClass2["default"])(VariableContainer, [{
    key: "createDom",
    value: function createDom(view) {
      var createElement = Entry.createElement;
      var that = this;
      this.filterElements = {};
      this.view_ = view;
      var selectView = createElement('table').addClass('entryVariableSelectorWorkspace').appendTo(this.view_);
      $(selectView).on('click tab', 'td', function () {
        if (this.disabled) {
          return;
        }
        Entry["do"]('variableContainerSelectFilter', this.getAttribute('data-type'), that.viewMode_);
      });
      var selectTrView = createElement('tr').appendTo(selectView);
      var allButton = this.createSelectButton('all').addClass('selected', 'allButton').appendTo(selectTrView);
      this.filterElements.all = allButton;
      allButton.setAttribute('rowspan', '2');
      this.filterElements.variable = this.createSelectButton('variable', Entry.variableEnable).appendTo(selectTrView);
      this.filterElements.message = this.createSelectButton('message', Entry.messageEnable).appendTo(selectTrView);
      selectTrView = createElement('tr').appendTo(selectView);
      this.filterElements.list = this.createSelectButton('list', Entry.listEnable).appendTo(selectTrView);
      this.filterElements.func = this.createSelectButton('func', Entry.functionEnable).appendTo(selectTrView);
      var listViewContainer = createElement('div').addClass('entryVariableListWorkspace');
      this.view_.appendChild(listViewContainer);
      var listView = createElement('div').addClass('entryVariableAdd_box').appendTo(listViewContainer);
      $(listView).on('mouseenter', '.entryVariableListElementWorkspace', function () {
        this.addClass('active');
      });
      $(listView).on('mouseleave', '.entryVariableListElementWorkspace', function () {
        this.removeClass('active');
      });
      this.listView_ = listView;
      this.generateAddButtons();
      this.generateVariableAddView();
      this.generateListAddView();
      this.generateMessageAddView();
      return view;
    }
  }, {
    key: "generateAddButtons",
    value: function generateAddButtons() {
      var createElement = Entry.createElement;
      var variableAddButton = createElement('button').addClass('entryVariableAddWorkspace');
      variableAddButton.textContent = Lang.Workspace.variable_add;
      this.variableAddButton_ = variableAddButton;
      var messageAddButton = createElement('button').addClass('entryVariableAddWorkspace');
      messageAddButton.textContent = Lang.Workspace.message_add;
      this.messageAddButton_ = messageAddButton;
      var listAddButton = createElement('button').addClass('entryVariableAddWorkspace');
      listAddButton.textContent = Lang.Workspace.list_create;
      this.listAddButton_ = listAddButton;
      var functionAddButton = createElement('button').addClass('entryVariableAddWorkspace').addClass('funcAddButton');
      functionAddButton.textContent = Lang.Workspace.function_add;
      this.functionAddButton_ = functionAddButton;
    }

    /**
     * @param {String} type
     * @param {?Boolean} isEnable
     */
  }, {
    key: "createSelectButton",
    value: function createSelectButton(type) {
      var isEnable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var view = Entry.createElement('td').addClass('entryVariableSelectButtonWorkspace', type);
      var textView = Entry.createElement('div');
      var text = Entry.createElement('span').addClass('text').appendTo(textView);
      view.setAttribute('data-type', type);
      view.appendChild(textView);
      text.innerText = Lang.Workspace[type];
      if (isEnable === false) {
        view.addClass('disabled');
        view.disabled = true;
      }
      this._filterTabs[type] = view;
      return view;
    }

    /**
     * @param {String} type
     */
  }, {
    key: "selectFilter",
    value: function selectFilter(type) {
      _.each(this.view_.getElementsByTagName('td'), function (elem) {
        if (elem.hasClass(type)) {
          elem.addClass('selected');
        } else {
          elem.removeClass('selected');
        }
      });
      this.viewMode_ = type;
      this.select();
      this.updateList();
    }
  }, {
    key: "updateVariableAddView",
    value: function updateVariableAddView() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'variable';
      var _this$_getAddPanel = this._getAddPanel(type),
        _this$_getAddPanel$in = _this$_getAddPanel.info,
        isCloud = _this$_getAddPanel$in.isCloud,
        object = _this$_getAddPanel$in.object,
        isRealTime = _this$_getAddPanel$in.isRealTime,
        view = _this$_getAddPanel.view;
      var cloudCheck = view.cloudCheck,
        globalCheck = view.globalCheck,
        localCheck = view.localCheck,
        cloudWrapper = view.cloudWrapper;
      _assertClassBrand(_VariableContainer_brand, this, _removeChildrenClass).call(this, cloudCheck, 'on');
      var _cloudCheck$children = (0, _slicedToArray2["default"])(cloudCheck.children, 3),
        normal = _cloudCheck$children[0],
        cloud = _cloudCheck$children[1],
        realtime = _cloudCheck$children[2];
      if (isCloud) {
        cloud.addClass('on');
      } else if (isRealTime) {
        realtime.addClass('on');
      } else {
        normal.addClass('on');
      }
      if (object) {
        globalCheck.removeClass('on');
        localCheck.addClass('on');
        cloudWrapper.addClass('entryVariableAddSpaceUnCheckedWorkspace');
      } else {
        globalCheck.addClass('on');
        localCheck.removeClass('on');
        cloudWrapper.removeClass('entryVariableAddSpaceUnCheckedWorkspace');
      }
    }

    /**
     * @param {object|Entry.Variable} object
     */
  }, {
    key: "select",
    value: function select(object) {
      object = this.selected == object ? null : object;
      if (this.selected) {
        this.selected.listElement.removeClass('unfold');
        this.selected.listElement.addClass('fold');
        this.selected.listElement.removeClass('selected');
        if (this.selected.callerListElement) {
          $(this.selected.callerListElement).remove();
          delete this.selected.callerListElement;
        }
        this.selected = null;
      }
      if (!object) {
        return;
      }
      object.listElement.addClass('selected');
      this.selected = object;
      this.selected.listElement.removeClass('fold');
      this.selected.listElement.addClass('unfold');
      if (object instanceof Entry.Variable) {
        if (object.type === 'variable') {
          this.generateVariableSettingView(object);
          this.updateVariableSettingView(object);
        } else if (object.type === 'list') {
          this.generateListSettingView(object);
          this.updateListSettingView(object);
        }
        if (object.object_) {
          Entry.container.selectObject(object.object_, true);
        }
      } else if (object instanceof Entry.Func) {
        this.generateFuncSettingView(object);
        this.updateFuncSettingView(object);
      } else {
        this.renderMessageReference(object);
      }
    }
  }, {
    key: "getMessage",
    value: function getMessage(id) {
      return _.find(this.messages_, {
        id: id
      });
    }

    /**
     * @param {object} message
     */
  }, {
    key: "renderMessageReference",
    value: function renderMessageReference(message) {
      var messageId = message.id;
      var hasInFunction = this.hasParamBlockInFunction(messageId);
      var callers = this._messageRefs.filter(function (_ref) {
        var params = _ref.block.params;
        return (0, _includes2["default"])(params, messageId);
      });
      message.usedView && $(message.usedView).remove();
      var usedWrapper = Entry.createElement('div').addClass('use_block');
      var boxSubject = Entry.createElement('span').addClass('box_sjt').appendTo(usedWrapper);
      if (callers.length) {
        boxSubject.textContent = Entry.Utils.stringFormat(Lang.Workspace.use_block_objects1, callers.length);
        var listView = Entry.createElement('ul').addClass('obj_list').appendTo(usedWrapper);
        var fragment = document.createDocumentFragment();
        callers.forEach(function (caller) {
          var element = Entry.createElement('li');
          var object = caller.object;
          if (!object.entity) {
            return;
          }
          !caller.object.thumbnailView_ && caller.object.generateView();
          var thumb = element.appendChild(caller.object.thumbnailView_.cloneNode());
          thumb.addClass('thmb');
          element.appendChild(thumb);
          Entry.createElement('span').addClass('text').appendTo(element).textContent = "".concat(caller.object.name, " : ").concat(Lang.Blocks["START_".concat(caller.block.type)]);
          element.bindOnClick(function (e) {
            e.stopPropagation();
            if (Entry.playground.object !== caller.object) {
              Entry.container.selectObject();
              Entry.container.selectObject(caller.object.id, true);
            }
            var block = caller.block;
            var board = _.result(block.view, 'getBoard');
            if (board) {
              board.setSelectedBlock(block.view);
            }
            Entry.playground.toggleOnVariableView();
            Entry.playground.changeViewMode('variable');
          });
          fragment.appendChild(element);
        });
        listView.appendChild(fragment);
      } else {
        var caution = Entry.createElement('div').addClass('caution_dsc').appendTo(usedWrapper);
        caution.textContent = Lang.Workspace.no_use;
        boxSubject.textContent = Entry.Utils.stringFormat(Lang.Workspace.use_block_objects2, callers.length);
      }
      if (hasInFunction) {
        var usedInFunction = Entry.createElement('div').addClass('used_function_dsc').appendTo(usedWrapper);
        usedInFunction.textContent = Lang.Workspace.use_block_function;
      }
      message.usedView = usedWrapper;
      message.listElement.appendChild(usedWrapper);
    }

    /**
     * @param {object} variable
     */
  }, {
    key: "renderVariableReference",
    value: function renderVariableReference(variable) {
      var variableId = variable.id_;
      var hasInFunction = this.hasParamBlockInFunction(variableId);
      var callers = this._variableRefs.filter(function (_ref2) {
        var params = _ref2.block.params;
        return (0, _includes2["default"])(params, variableId);
      });
      var usedWrapper = Entry.createElement('div').addClass('use_obj');
      var usedSubject = Entry.createElement('span').addClass('box_sjt').appendTo(usedWrapper);
      var listView = Entry.createElement('ul').addClass('obj_list').appendTo(usedWrapper);
      if (callers.length) {
        usedSubject.textContent = Entry.Utils.stringFormat(Lang.Workspace.use_block_objects1, callers.length);
        var fragment = document.createDocumentFragment();
        callers.forEach(function (caller) {
          var element = Entry.createElement('li');
          var object = caller.object;
          if (!object.entity) {
            return;
          }
          !caller.object.thumbnailView_ && caller.object.generateView();
          var thumb = caller.object.thumbnailView_.cloneNode();
          thumb.addClass('thmb');
          element.appendChild(thumb);
          Entry.createElement('span').addClass('text').appendTo(element).textContent = "".concat(caller.object.name, " : ").concat(Lang.Blocks["VARIABLE_".concat(caller.block.type)]);
          element.variable = variable;
          element.bindOnClick(function (e) {
            e.stopPropagation();
            if (Entry.playground.object != caller.object) {
              Entry.container.selectObject();
              Entry.container.selectObject(caller.object.id, true);
            }
            var block = caller.block;
            var board = _.result(block.view, 'getBoard');
            if (board) {
              board.setSelectedBlock(block.view);
            }
            Entry.playground.toggleOnVariableView();
            Entry.playground.changeViewMode('variable');
          });
          fragment.appendChild(element);
        });
        listView.appendChild(fragment);
      } else {
        usedSubject.textContent = Entry.Utils.stringFormat(Lang.Workspace.use_block_objects2, callers.length);
        Entry.createElement('div').addClass('caution_dsc').appendTo(listView).textContent = Lang.Workspace.no_use;
      }
      if (hasInFunction) {
        var usedInFunction = Entry.createElement('div').addClass('used_function_dsc').appendTo(listView);
        usedInFunction.textContent = Lang.Workspace.use_block_function;
      }
      this.variableSettingView && this.variableSettingView.appendChild(usedWrapper);
      this.listSettingView && this.listSettingView.appendChild(usedWrapper);
    }
  }, {
    key: "generateFuncSettingView",
    value: function generateFuncSettingView(func) {
      var createElement = Entry.createElement;
      var element = createElement('div').addClass('attr_inner_box').bindOnClick(function (e) {
        return e.stopPropagation();
      });
      if (this.funcSettingView) {
        $(this.funcSettingView).remove();
        delete this.funcSettingView;
      }
      this.funcSettingView = element;
      var funcAttr = createElement('div').addClass('func_attr').appendTo(element);
      if (this._isPythonMode()) {
        funcAttr.addClass('hidden');
      }
      var boxSubject = createElement('span').addClass('box_sjt').appendTo(funcAttr);
      boxSubject.textContent = Lang.Workspace.func_property;
      this.generateFuncDefaultView(funcAttr, func);
      this.generateFuncLocalVariableView(funcAttr, func);
      this.generateFuncValuesView(funcAttr, func);
      this.renderFunctionReference(func);
      this.funcSettingView.func = funcAttr;
      func.listElement.appendChild(this.funcSettingView);
    }
  }, {
    key: "isUsedFunction",
    value: function isUsedFunction(func) {
      var _this2 = this;
      if ((0, _toConsumableArray2["default"])(this._functionRefs).some(function (item) {
        return item.block.data.type === "func_".concat(func.id);
      })) {
        return true;
      } else if (Object.keys(this.functions_).some(function (key) {
        var _this2$functions_$key;
        var item = (_this2$functions_$key = _this2.functions_[key]) === null || _this2$functions_$key === void 0 ? void 0 : _this2$functions_$key.content.findByType("func_".concat(func.id));
        return Boolean(item);
      })) {
        return true;
      }
      return false;
    }
  }, {
    key: "generateFuncDefaultView",
    value: function generateFuncDefaultView(element, func) {
      var _this3 = this;
      var createElement = Entry.createElement;

      // 슬라이드 입력창
      var checkInputBox = createElement('div').addClass('check_inpt').appendTo(element);
      var resultCheckBox = createElement('div').addClass('chk_box').appendTo(checkInputBox);
      element.resultCheck = createElement('span').addClass('entryFuncAddResultCheckWorkspace').bindOnClick(function () {
        if (_this3.isUsedFunction(func)) {
          return Entry.modal.alert(Lang.Msgs.cannot_delete_function);
        }
        Entry["do"]('funcChangeType', func);
      }).appendTo(resultCheckBox);
      var resultCheckText = createElement('span').addClass('chk_text').bindOnClick(function () {
        if (_this3.isUsedFunction(func)) {
          return Entry.modal.alert(Lang.Msgs.cannot_delete_function);
        }
        Entry["do"]('funcChangeType', func);
      }).appendTo(resultCheckBox);
      resultCheckText.textContent = Lang.Workspace.check_result_value;
    }
  }, {
    key: "generateFuncLocalVariableView",
    value: function generateFuncLocalVariableView(element, func) {
      var _func$localVariables;
      var createElement = Entry.createElement;
      var checkInputBox = createElement('div').addClass('check_inpt').appendTo(element);
      var localVarCheckBox = createElement('div').addClass('chk_box').appendTo(checkInputBox);
      element.localVarCheck = createElement('span').addClass('entryFuncAddLocalVarCheckWorkspace').bindOnClick(function () {
        var isUseBlock = func.content.hasBlockType(['set_func_variable', 'get_func_variable']);
        if (isUseBlock) {
          Entry.modal.confirm(Lang.Msgs.local_variable_deletion_warning).then(function (result) {
            if (result) {
              func.content.getBlockList(false, ['set_func_variable', 'get_func_variable']).map(Entry.Utils.runAsyncCurry(/*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(block) {
                  return _regenerator["default"].wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        Entry["do"]('destroyBlock', block).isPass(true);
                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }()));
              Entry["do"]('toggleFuncUseLocalVariables', func);
            }
          });
        } else {
          Entry["do"]('toggleFuncUseLocalVariables', func);
        }
      }).appendTo(localVarCheckBox);
      var localVarCheckText = createElement('span').addClass('chk_text').bindOnClick(function () {
        element.localVarCheck.click();
      }).appendTo(localVarCheckBox);
      localVarCheckText.textContent = Lang.Workspace.check_local_variable;
      var countInputBox = createElement('div').addClass('cnt_inpt').appendTo(checkInputBox);
      var buttonMinus = createElement('a').addClass('btn_cnt').bindOnClick(function (e) {
        var _e$target;
        var disabled = e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.hasAttribute('disabled');
        if (disabled) {
          return;
        }
        Entry["do"]('funcLocalVarChangeLength', func, 'minus');
        Entry.dispatchEvent('changeFuncVariableListSize');
      }).appendTo(countInputBox);
      this.funcSettingView.minus = buttonMinus;
      var limitValue = 10;
      var maxlength = 2;
      var countInput = createElement('input').appendTo(countInputBox);
      countInput.setAttribute('autocomplete', 'off');
      countInput.setAttribute('type', 'text');
      countInput.setAttribute('maxlength', maxlength);
      countInput.value = ((_func$localVariables = func.localVariables) === null || _func$localVariables === void 0 ? void 0 : _func$localVariables.length) || 0;
      countInput.onblur = function (e) {
        var _e$target2;
        var disabled = e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.hasAttribute('disabled');
        if (disabled) {
          return;
        }
        var value = (0, _get2["default"])(e, 'target.value', 0);
        if (value >= limitValue) {
          value = limitValue;
        }
        Entry["do"]('funcLocalVarChangeLength', func, value);
        Entry.dispatchEvent('changeFuncVariableListSize');
      };
      countInput.onkeypress = Entry.Utils.blurWhenEnter;
      var buttonPlus = createElement('a').addClass('btn_cnt').addClass('plus').bindOnClick(function (e) {
        var _e$target3;
        var disabled = e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.hasAttribute('disabled');
        if (disabled) {
          return;
        }
        var variableLength = func.localVariables.length;
        if (variableLength < limitValue) {
          Entry["do"]('funcLocalVarChangeLength', func, 'plus');
          Entry.dispatchEvent('changeFuncVariableListSize');
        }
      }).appendTo(countInputBox);
      this.funcSettingView.plus = buttonPlus;
      this.funcSettingView.lengthInput = countInput;
    }
  }, {
    key: "generateFuncValuesView",
    value: function generateFuncValuesView(element, func) {
      var _this4 = this;
      var localVariables = func.getLocalVariables() || [];
      if ((localVariables === null || localVariables === void 0 ? void 0 : localVariables.length) === 0) {
        return;
      }
      var createElement = Entry.createElement;
      var countGroup = createElement('div').addClass('cnt_group').appendTo(element);
      var countLabel = createElement('div').addClass('cnt_label').appendTo(countGroup);
      countLabel.textContent = Lang.Workspace.local_variable;
      var scrollBox = createElement('div').addClass('scroll_box simplebar-content-wrapper').appendTo(countGroup);
      var el = new _simplebar["default"](scrollBox, {
        autoHide: false
      });
      var parent = /* html */"<ol class=\"cnt_list\">{1}</ol>";
      this.funcSettingView.countGroup = countGroup;
      this.funcSettingView.scrollBox = scrollBox;
      this.funcSettingView.simpleBar = el;
      var listValues = el.getContentElement();
      this.funcSettingView.listValues = listValues;
      var infinityScroll = new Entry.VirtualScroll(listValues, {
        dataWrapper: parent,
        itemHeight: 24,
        groupSize: 10
      });
      this.funcSettingView.infinityScroll = infinityScroll;
      var $listValues = $(listValues);
      $listValues.empty();
      $listValues.off();
      var data = localVariables === null || localVariables === void 0 ? void 0 : localVariables.map(function (data, i) {
        var value = String(data.name).replace(/\$/g, '&#36;');
        return _this4.createListValueElement(i, value, 1);
      });
      infinityScroll.assignData(data);
      infinityScroll.show();
      $listValues.on('change', 'input', _.debounce(function (e) {
        var target = e.target;
        var index = target.getAttribute('data-index');
        func.changeNameLocalVariable(target.value, index);
      }));
      $listValues.on('focus', 'input', Entry.Utils.setFocused);
      $listValues.on('keypress', 'input', Entry.Utils.blurWhenEnter);
      $listValues.on('click', 'a', function () {
        var index = this.getAttribute('data-index');
        Entry["do"]('removeFuncLocalVariableByIndex', func, index);
        Entry.dispatchEvent('changeFuncVariableListSize');
      });
    }
  }, {
    key: "updateFuncScrollBar",
    value: function updateFuncScrollBar(func) {
      var _this5 = this,
        _func$localVariables2;
      var view = this.funcSettingView;
      if (!view) {
        return;
      }
      if (!view.infinityScroll) {
        this.generateFuncValuesView(this.funcSettingView.func, func);
        requestAnimationFrame(function () {
          _this5.updateFuncScrollBar(func);
        });
        return;
      }
      var localVariables = func.getLocalVariables() || [];
      var infinityScroll = view.infinityScroll,
        countGroup = view.countGroup,
        lengthInput = view.lengthInput,
        simpleBar = view.simpleBar,
        scrollBox = view.scrollBox;
      lengthInput.value = ((_func$localVariables2 = func.localVariables) === null || _func$localVariables2 === void 0 ? void 0 : _func$localVariables2.length) || 0;
      if ((localVariables === null || localVariables === void 0 ? void 0 : localVariables.length) === 0) {
        countGroup === null || countGroup === void 0 || countGroup.addClass('entryRemove');
        return;
      }
      countGroup === null || countGroup === void 0 || countGroup.removeClass('entryRemove');
      var data = localVariables === null || localVariables === void 0 ? void 0 : localVariables.map(function (data, i) {
        var value = String(data.name).replace(/\$/g, '&#36;');
        return _this5.createListValueElement(i, value, 1);
      });
      infinityScroll.assignData(data);
      infinityScroll.show();
      if ((localVariables === null || localVariables === void 0 ? void 0 : localVariables.length) > 4) {
        scrollBox.addClass('on');
      } else {
        scrollBox.removeClass('on');
      }
      simpleBar.recalculate();
    }
  }, {
    key: "updateFuncSettingView",
    value: function updateFuncSettingView(func) {
      var view = this.funcSettingView;
      if (!view) {
        return;
      }
      if (func.type === 'value') {
        view.func.resultCheck.addClass('on');
      } else {
        view.func.resultCheck.removeClass('on');
      }
      if (func.useLocalVariables) {
        var _this$funcSettingView;
        view.func.localVarCheck.addClass('on');
        this.funcSettingView.minus.removeAttribute('disabled');
        this.funcSettingView.plus.removeAttribute('disabled');
        this.funcSettingView.lengthInput.removeAttribute('disabled');
        (_this$funcSettingView = this.funcSettingView) === null || _this$funcSettingView === void 0 || (_this$funcSettingView = _this$funcSettingView.countGroup) === null || _this$funcSettingView === void 0 || _this$funcSettingView.removeAttribute('disabled');
      } else {
        var _this$funcSettingView2;
        view.func.localVarCheck.removeClass('on');
        this.funcSettingView.minus.setAttribute('disabled', '');
        this.funcSettingView.plus.setAttribute('disabled', '');
        this.funcSettingView.lengthInput.setAttribute('disabled', '');
        (_this$funcSettingView2 = this.funcSettingView) === null || _this$funcSettingView2 === void 0 || (_this$funcSettingView2 = _this$funcSettingView2.countGroup) === null || _this$funcSettingView2 === void 0 || _this$funcSettingView2.setAttribute('disabled', '');
      }
      this.updateFuncScrollBar(func);
    }

    /**
     * @param {object} variable
     */
  }, {
    key: "renderFunctionReference",
    value: function renderFunctionReference(func) {
      var createElement = Entry.createElement;
      var funcId = func.id;
      var hasInFunction = this.hasFuncBlockInFunction(funcId);
      var callers = (0, _toConsumableArray2["default"])(this._functionRefs).filter(function (item) {
        return item.block.data.type === "func_".concat(funcId);
      });
      func.usedView && $(func.usedView).remove();
      var wrapper = createElement('div').addClass('use_block');
      var boxSubject = createElement('span').addClass('box_sjt').appendTo(wrapper);
      if (callers.length) {
        boxSubject.textContent = Entry.Utils.stringFormat(Lang.Workspace.use_block_objects1, callers.length);
        var listView = createElement('ul').addClass('obj_list').appendTo(wrapper);
        var fragment = document.createDocumentFragment();
        callers.forEach(function (caller) {
          var element = createElement('li');
          var object = caller.object;
          if (!object.entity) {
            return;
          }
          !caller.object.thumbnailView_ && caller.object.generateView();
          var thumb = element.appendChild(caller.object.thumbnailView_.cloneNode());
          thumb.addClass('thmb');
          element.appendChild(thumb);
          var nameElement = createElement('span').addClass('text');
          nameElement.textContent = caller.object.name;
          element.appendChild(nameElement);
          element.bindOnClick(function () {
            if (Entry.playground.object != caller.object) {
              Entry.container.selectObject();
              Entry.container.selectObject(caller.object.id, true);
            }
            Entry.playground.toggleOnVariableView();
            var block = caller.block;
            var blockView = block.view;
            blockView && blockView.getBoard().setSelectedBlock(block.view);
            Entry.playground.changeViewMode('variable');
          });
          fragment.appendChild(element);
        });
        listView.appendChild(fragment);
      } else {
        var caution = createElement('div').addClass('caution_dsc').appendTo(wrapper);
        caution.textContent = Lang.Workspace.no_use;
        boxSubject.textContent = Lang.Workspace.use_block_objects2;
      }
      if (hasInFunction) {
        var usedInFunction = createElement('div').addClass('used_function_dsc').appendTo(wrapper);
        usedInFunction.textContent = Lang.Workspace.use_block_function;
      }
      func.usedView = wrapper;
      this.funcSettingView && this.funcSettingView.appendChild(wrapper);
    }

    /**
     * update list view
     */
  }, {
    key: "updateList",
    value: function updateList() {
      var listView = this.listView_;
      if (!listView) {
        return;
      }
      var isPythonMode = this._isPythonMode();
      if (isPythonMode) {
        listView.addClass('entryVariableContainerTextMode');
      } else {
        listView.removeClass('entryVariableContainerTextMode');
      }
      this.clearListElement();
      switch (this.viewMode_) {
        case 'all':
          this.updateAllTab();
          break;
        case 'message':
          this.updateMessageTab();
          break;
        case 'variable':
          this.updateVariableTab();
          break;
        case 'list':
          this.updateListTab();
          break;
        case 'func':
          this.updateFuncTab();
          break;
      }
      this.updateSelected();
    }
  }, {
    key: "updateFuncVariableList",
    value: function updateFuncVariableList() {
      var _Entry$block, _Entry$block2;
      [].concat((0, _toConsumableArray2["default"])(((_Entry$block = Entry.block) === null || _Entry$block === void 0 || (_Entry$block = _Entry$block.set_func_variable) === null || _Entry$block === void 0 || (_Entry$block = _Entry$block.events) === null || _Entry$block === void 0 ? void 0 : _Entry$block.updateFuncVariableList) || []), (0, _toConsumableArray2["default"])(((_Entry$block2 = Entry.block) === null || _Entry$block2 === void 0 || (_Entry$block2 = _Entry$block2.get_func_variable) === null || _Entry$block2 === void 0 || (_Entry$block2 = _Entry$block2.events) === null || _Entry$block2 === void 0 ? void 0 : _Entry$block2.updateFuncVariableList) || [])).forEach(function (fn) {
        if ((0, _isFunction2["default"])(fn)) {
          fn();
        }
      });
    }
  }, {
    key: "makeChildVariableViews",
    value: function makeChildVariableViews(arr, viewFunc) {
      var _this6 = this;
      var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.listView_;
      return _.each(arr, function (data) {
        !data.listElement && viewFunc(data);
        if (_this6._isPythonMode()) {
          $(data.listElement).find('input').each(function () {
            $(this).attr('disabled', 'disabled');
          });
        } else {
          $(data.listElement).find('input').each(function () {
            $(this).removeAttr('disabled');
          });
        }
        parent.appendChild(data.listElement);
      });
    }
  }, {
    key: "clearListElement",
    value: function clearListElement() {
      var clearList = [this.listView_];
      for (var _i = 0, _clearList = clearList; _i < _clearList.length; _i++) {
        var elem = _clearList[_i];
        while (elem && elem.firstChild) {
          elem.removeChild(elem.lastChild);
        }
      }
      var arrItems = [this.messages_, this.variables_, this.lists_, this.functions_];
      arrItems.forEach(function (items) {
        Object.values(items).forEach(function (item) {
          if (item.listElement) {
            item.listElement.removeClass('unfold').removeClass('selected').addClass('fold');
          }
        });
      });
      if (this.listSettingView) {
        $(this.listSettingView).remove();
        delete this.listSettingView;
      }
      if (this.variableSettingView) {
        $(this.variableSettingView).remove();
        delete this.variableSettingView;
      }
      if (this.funcSettingView) {
        $(this.funcSettingView).remove();
        delete this.funcSettingView;
      }
    }
  }, {
    key: "updateAllTab",
    value: function updateAllTab() {
      var createElement = Entry.createElement;
      var listView = this.listView_;
      var listWrapper = createElement('div').addClass('entryVariableSplitterWorkspace unfold all');
      var listBox = createElement('div').addClass('attr_box unfold').appendTo(listWrapper);
      var list = createElement('div').addClass('list').appendTo(listBox);
      this.makeChildVariableViews(this.messages_, this.createMessageView.bind(this), list);
      this.makeChildVariableViews(this.variables_, this.createVariableView.bind(this), list);
      this.makeChildVariableViews(this.lists_, this.createListView.bind(this), list);
      this.makeChildVariableViews(this.functions_, this.createFunctionView.bind(this), list);
      listView.appendChild(listWrapper);
    }
  }, {
    key: "updateMessageTab",
    value: function updateMessageTab() {
      var createElement = Entry.createElement;
      var listView = this.listView_;
      if (Entry.isTextMode) {
        this.messageAddButton_.unBindOnClick().addClass('disabled');
      } else {
        this.messageAddButton_.unBindOnClick().bindOnClick(function () {
          return Entry["do"]('variableContainerClickMessageAddButton');
        }).removeClass('disabled');
      }
      listView.appendChild(this.messageAddButton_);
      listView.appendChild(this.messageAddPanel.view);
      var messageList = createElement('div').addClass('entryVariableSplitterWorkspace message unfold');
      var messageListBox = createElement('div').addClass('attr_box').appendTo(messageList);
      var list = createElement('div').addClass('list').appendTo(messageListBox);
      this.makeChildVariableViews(this.messages_, this.createMessageView.bind(this), list);
      listView.appendChild(messageList);
    }
  }, {
    key: "updateVariableTab",
    value: function updateVariableTab() {
      var _this7 = this;
      var createElement = Entry.createElement;
      var listView = this.listView_;
      var info = this.variableAddPanel.info;
      if (info.object && !Entry.playground.object) {
        info.object = null;
      }
      if (Entry.isTextMode) {
        this.variableAddButton_.unBindOnClick().addClass('disabled');
      } else {
        this.variableAddButton_.unBindOnClick().bindOnClick(function () {
          return Entry["do"]('variableContainerClickVariableAddButton');
        }).removeClass('disabled');
      }
      listView.appendChild(this.variableAddButton_);
      listView.appendChild(this.variableAddPanel.view);

      //global list container
      var globalList = createElement('div').addClass('entryVariableSplitterWorkspace variable global');
      var isGlobalFolded = false;
      var globalListTitle = Entry.createElement('a').addClass('attr_link').bindOnClick(function () {
        isGlobalFolded = !isGlobalFolded;
        _this7.foldTab(globalList, isGlobalFolded, gLength);
      }).appendTo(globalList);
      var globalListBox = createElement('div').addClass('attr_box').appendTo(globalList);

      //local list container
      var localList = createElement('div').addClass('entryVariableSplitterWorkspace variable local');
      var isLocalFolded = false;
      var localListTitle = Entry.createElement('a').addClass('attr_link').bindOnClick(function () {
        isLocalFolded = !isLocalFolded;
        _this7.foldTab(localList, isLocalFolded, lLength);
      }).appendTo(localList);
      var localListBox = createElement('div').addClass('attr_box').appendTo(localList);
      var _$groupBy = _.groupBy(this.variables_, function (_ref4) {
          var object_ = _ref4.object_;
          return object_ ? 'localV' : 'globalV';
        }),
        globalV = _$groupBy.globalV,
        localV = _$groupBy.localV;
      var gLength = (globalV || []).length;
      var lLength = (localV || []).length;
      globalListTitle.textContent = "".concat(Lang.Workspace.Variable_used_at_all_objects, " (").concat(gLength, ")");
      // eslint-disable-next-line max-len
      localListTitle.textContent = "".concat(Lang.Workspace.Variable_used_at_special_object, " (").concat(lLength, ")");
      this.foldTab(globalList, isGlobalFolded, gLength);
      this.foldTab(localList, isLocalFolded, lLength);
      listView.appendChild(globalList);
      this.makeChildVariableViews(globalV, this.createVariableView.bind(this), globalListBox);
      listView.appendChild(localList);
      this.makeChildVariableViews(localV, this.createVariableView.bind(this), localListBox);
      this.updateVariableAddView('variable');
    }
  }, {
    key: "foldTab",
    value: function foldTab(tab, isFold) {
      var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      if (!count) {
        return;
      }
      if (isFold) {
        tab.removeClass('unfold');
        tab.addClass('fold');
      } else {
        tab.addClass('unfold');
        tab.removeClass('fold');
      }
    }
  }, {
    key: "updateListTab",
    value: function updateListTab() {
      var _this8 = this;
      var createElement = Entry.createElement;
      var listView = this.listView_;
      var info = this.listAddPanel.info;
      if (info.object && !Entry.playground.object) {
        info.object = null;
      }
      if (Entry.isTextMode) {
        this.listAddButton_.unBindOnClick().addClass('disabled');
      } else {
        this.listAddButton_.unBindOnClick().bindOnClick(function () {
          return Entry["do"]('variableContainerClickListAddButton');
        }).removeClass('disabled');
      }
      listView.appendChild(this.listAddButton_);
      listView.appendChild(this.listAddPanel.view);

      //global list container
      var globalList = createElement('div').addClass('entryVariableSplitterWorkspace list global');
      var isGlobalFolded = false;
      var globalListTitle = Entry.createElement('a').addClass('attr_link').bindOnClick(function () {
        isGlobalFolded = !isGlobalFolded;
        _this8.foldTab(globalList, isGlobalFolded, gLength);
      }).appendTo(globalList);
      var globalListBox = createElement('div').addClass('attr_box').appendTo(globalList);

      //local list container
      var localList = createElement('div').addClass('entryVariableSplitterWorkspace list local');
      var isLocalFolded = false;
      var localListTitle = Entry.createElement('a').addClass('attr_link').bindOnClick(function () {
        isLocalFolded = !isLocalFolded;
        _this8.foldTab(localList, isLocalFolded, lLength);
      }).appendTo(localList);
      var localListBox = createElement('div').addClass('attr_box').appendTo(localList);
      var _$groupBy2 = _.groupBy(this.lists_, function (_ref5) {
          var object_ = _ref5.object_;
          return object_ ? 'localV' : 'globalV';
        }),
        localV = _$groupBy2.localV,
        globalV = _$groupBy2.globalV;
      var gLength = (globalV || []).length;
      var lLength = (localV || []).length;
      globalListTitle.textContent = "".concat(Lang.Workspace.List_used_all_objects, " (").concat(gLength, ")");
      localListTitle.textContent = "".concat(Lang.Workspace.list_used_specific_objects, " (").concat(lLength, ")");
      this.foldTab(globalList, isGlobalFolded, gLength);
      this.foldTab(localList, isLocalFolded, lLength);
      listView.appendChild(globalList);
      this.makeChildVariableViews(globalV, this.createListView.bind(this), globalListBox);
      listView.appendChild(localList);
      this.makeChildVariableViews(localV, this.createListView.bind(this), localListBox);
      this.updateVariableAddView('variable');
    }
  }, {
    key: "updateFuncTab",
    value: function updateFuncTab() {
      var createElement = Entry.createElement;
      var listView = this.listView_;
      if (Entry.isTextMode) {
        this.functionAddButton_.unBindOnClick().addClass('disabled');
      } else {
        this.functionAddButton_.unBindOnClick().bindOnClick(function () {
          return Entry["do"]('funcEditStart', Entry.generateHash());
        }).removeClass('disabled');
      }
      listView.appendChild(this.functionAddButton_);
      var funcList = createElement('div').addClass('entryVariableSplitterWorkspace func unfold');
      var funcListBox = createElement('div').addClass('attr_box').appendTo(funcList);
      this.makeChildVariableViews(this.functions_, this.createFunctionView.bind(this), funcListBox);
      listView.appendChild(funcList);
    }

    /**
     * @param {!Array.<message model>} objectModels
     */
  }, {
    key: "setMessages",
    value: function setMessages() {
      var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.messages_ = messages.map(function (message) {
        if (!message.id) {
          message.id = Entry.generateHash();
        }
        return message;
      });
      Entry.playground.reloadPlayground();
    }

    /**
     * @param {!Array.<message model>} objectModels
     */
  }, {
    key: "appendMessages",
    value: function appendMessages(messages) {
      var _this9 = this;
      var _loop = function _loop() {
        var message = messages[i];
        if (!message.id) {
          message.id = Entry.generateHash();
        } else if (_this9.messages_.some(function (item) {
          return item.id === message.id;
        })) {
          return 1; // continue
        }
        var name = message.name;
        name = _this9.checkAllVariableName(name, 'messages_', 'name') ? Entry.getOrderedName(name, _this9.messages_, 'name') : name;
        message.name = name;
        _this9.messages_.push(message);
      };
      for (var i in messages) {
        if (_loop()) continue;
      }
      Entry.playground.reloadPlayground();
    }

    /**
     * @param {!Array.<variable model>} variables
     */
  }, {
    key: "setVariables",
    value: function setVariables() {
      var _this0 = this;
      var variables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var options = arguments.length > 1 ? arguments[1] : undefined;
      variables.forEach(function (variable) {
        variable = Entry.Variable.create(variable);
        switch (variable.getType()) {
          case 'variable':
          case 'slide':
            variable.generateView(_this0.variables_.length);
            _this0.variables_.push(variable);
            break;
          case 'list':
            variable.generateView(_this0.lists_.length);
            _this0.lists_.push(variable);
            break;
          case 'timer':
            _this0.generateTimer(variable);
            break;
          case 'answer':
            _this0.generateAnswer(variable);
            break;
        }
      });
      if (_.isEmpty(Entry.engine.projectTimer)) {
        this.generateTimer();
      }
      if (_.isEmpty(Entry.container.inputValue)) {
        this.generateAnswer();
      }
      if (_.isEmpty(Entry.container.sttValue)) {
        var _options$aiUtilizeBlo;
        this.generateStt();
        if (options !== null && options !== void 0 && (_options$aiUtilizeBlo = options.aiUtilizeBlocks) !== null && _options$aiUtilizeBlo !== void 0 && _options$aiUtilizeBlo.includes('audio')) {
          Entry.container.sttValue.setVisible(true);
        }
      }
      Entry.playground.reloadPlayground();
    }
  }, {
    key: "generateVariable",
    value: function generateVariable(variable, data, key) {
      var name = variable.name_;
      variable.name_ = this.checkAllVariableName(name, key) ? Entry.getOrderedName(name, data, 'name_') : name;
      variable.generateView(data.length);
    }

    /**
     * @param {!Array.<variable model>} variables
     */
  }, {
    key: "appendVariables",
    value: function appendVariables(variables) {
      var _this1 = this;
      var _loop2 = function _loop2() {
          var variable = Entry.Variable.create(variables[i]);
          if (!variable.id_) {
            variable.id_ = Entry.generateHash();
          }
          var type = variable.getType();
          if (type === 'variable' || type === 'slide') {
            if (_this1.variables_.some(function (item) {
              return item.id_ === variable.id_;
            })) {
              return 0; // continue
            }
            _this1.generateVariable(variable, _this1.variables_, 'variables_');
            _this1.variables_.push(variable);
          } else if (type === 'list') {
            if (_this1.lists_.some(function (item) {
              return item.id_ === variable.id_;
            })) {
              return 0; // continue
            }
            _this1.generateVariable(variable, _this1.lists_, 'lists_');
            _this1.lists_.push(variable);
          }
        },
        _ret;
      for (var i in variables) {
        _ret = _loop2();
        if (_ret === 0) continue;
      }
      if (Entry.isEmpty(Entry.engine.projectTimer)) {
        Entry.variableContainer.generateTimer();
      }
      if (Entry.isEmpty(Entry.container.inputValue)) {
        Entry.variableContainer.generateAnswer();
      }
      if (Entry.isEmpty(Entry.container.sttValue)) {
        Entry.variableContainer.generateStt();
      }
      Entry.playground.reloadPlayground();
    }

    /**
     * @param {!Array.<function model>} variables
     */
  }, {
    key: "setFunctions",
    value: function setFunctions() {
      var _this10 = this;
      var functions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      functions.forEach(function (func) {
        func = new Entry.Func(func);
        func.generateBlock();
        _this10.functions_[func.id] = func;
      });
    }

    /**
     * @param {!Array.<function model>} variables
     */
  }, {
    key: "appendFunctions",
    value: function appendFunctions() {
      var functions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      for (var i in functions) {
        var func = functions[i];
        if (!func.id) {
          func.id = Entry.generateHash();
        } else if ("".concat(func.id) in this.functions_) {
          continue;
        }
        var parseFunc = new Entry.Func(func);
        this.changeFunctionName(parseFunc);
        parseFunc.generateBlock();
        this.functions_[parseFunc.id] = parseFunc;
      }
    }
  }, {
    key: "changeFunctionName",
    value: function changeFunctionName(func) {
      var _this11 = this;
      var params = func.content.getEventMap('funcDef')[0].params[0].data.params;
      var funcParamInfo = this.getFunctionParamInfo(params);
      var funcParamName = this.getFunctionParamName(funcParamInfo);
      var funcKeys = Object.keys(this.functions_);
      var funcsParamNames = funcKeys.map(function (key) {
        var func = _this11.functions_[key];
        var params = func.content.getEventMap('funcDef')[0].params[0].data.params;
        var info = _this11.getFunctionParamInfo(params);
        return {
          name: _this11.getFunctionParamName(info)
        };
      });
      var isDuplecate = funcsParamNames.some(function (_ref6) {
        var name = _ref6.name;
        return funcParamName === name;
      });
      if (isDuplecate) {
        var orderedNumber = Entry.getOrderedNameNumber(funcParamName, funcsParamNames, 'name');
        for (var i = funcParamInfo.length - 1;; i--) {
          var info = funcParamInfo[i];
          if (info.type === 'string') {
            info.parent[0] += orderedNumber;
            break;
          }
        }
        Entry.Func.generateWsBlock(func);
      }
    }
  }, {
    key: "getFunctionParamName",
    value: function getFunctionParamName(info) {
      return info.reduce(function (acc, _ref7) {
        var name = _ref7.name;
        return acc += name;
      }, '');
    }
  }, {
    key: "getFunctionParamInfo",
    value: function getFunctionParamInfo(parentParams) {
      var _this12 = this;
      var info = [];
      parentParams.forEach(function (param, index) {
        if (typeof param === 'string') {
          info[index] = {
            name: param,
            type: 'string',
            parent: parentParams
          };
        } else if (param instanceof Entry.Block) {
          var _param$data = param.data,
            data = _param$data === void 0 ? {} : _param$data;
          var _data$params = data.params,
            params = _data$params === void 0 ? [] : _data$params,
            type = data.type;
          if (type.indexOf('stringParam') === 0 || type.indexOf('booleanParam') === 0) {
            var name = type.slice(0, -5);
            info[index] = {
              name: name,
              type: name,
              parent: parentParams
            };
          } else {
            var childParamInfo = _this12.getFunctionParamInfo(params);
            childParamInfo.forEach(function (childInfo, childIndex) {
              info[childIndex + index] = childInfo;
            });
          }
        }
      });
      return info;
    }

    /**
     * get func
     * @return {Entry.Func}
     */
  }, {
    key: "getFunction",
    value: function getFunction(funcId) {
      return this.functions_[funcId];
    }

    /**
     * get variable on canvas
     * @return {Entry.Variable}
     */
  }, {
    key: "getVariable",
    value: function getVariable(id_) {
      var entity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var criteria = {
        id_: id_
      };
      var variable = _.find(this.variables_, criteria);
      if (entity.isClone && variable.object_) {
        variable = _.find(entity.variables, criteria);
      }
      return variable;
    }

    /**
     * get variable on canvas
     * @return {Entry.List}
     */
  }, {
    key: "getList",
    value: function getList(listId) {
      var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        isClone = _ref8.isClone,
        lists = _ref8.lists;
      var criteria = {
        id_: listId
      };
      var list = _.find(this.lists_, criteria);
      if (isClone && list.object_) {
        list = _.find(lists, criteria);
      }
      return list;
    }

    /**
     * Create function
     */
  }, {
    key: "createFunction",
    value: function createFunction(data) {
      if (Entry.Func.isEdit) {
        Entry.modal.alert(Lang.Msgs.warning_function_aleady_being_edited, Lang.Workspace.function_create);
        return;
      }
      Entry.Func.edit(new Entry.Func(data));
      Entry.Func.save();
      this.select(Entry.Func.targetFunc);
    }
  }, {
    key: "removeBlocksInFunctionByType",
    value: function removeBlocksInFunctionByType(blockType) {
      Object.values(this.functions_).forEach(function (func) {
        Entry["do"]('funcEditStart', func.id).isPass(true);
        func.content.getBlockList(false, blockType).forEach(function (b, index) {
          Entry["do"]('destroyBlock', b).isPass(true);
        });
        Entry["do"]('funcEditEnd', 'save').isPass(true);
      });
    }
  }, {
    key: "removeBlocksInFunctionByType2",
    value: function removeBlocksInFunctionByType2(blockType) {
      Object.values(this.functions_).forEach(function (func) {
        func.content.getBlockList(false, blockType).forEach(function (block, index) {
          block.destroy();
        });
      });
    }
  }, {
    key: "removeBlocksInFunctionByTypeAsync",
    value: function () {
      var _removeBlocksInFunctionByTypeAsync = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(blockType) {
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return Promise.all(Object.values(this.functions_).map(/*#__PURE__*/function () {
                var _ref9 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(func) {
                  return _regenerator["default"].wrap(function (_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 1;
                        return Promise.all(func.content.getBlockList(false, blockType).map(Entry.Utils.runAsyncCurry(function (block) {
                          block.destroy();
                        })));
                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref9.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function removeBlocksInFunctionByTypeAsync(_x2) {
        return _removeBlocksInFunctionByTypeAsync.apply(this, arguments);
      }
      return removeBlocksInFunctionByTypeAsync;
    }()
  }, {
    key: "isUsedBlockTypeInFunction",
    value: function isUsedBlockTypeInFunction(blockType) {
      return Object.values(this.functions_).some(function (func) {
        return func.content.getBlockList(false, blockType).length;
      });
    }

    /**
     * Remove variable
     * @param {Entry.Variable} variable
     */
  }, {
    key: "removeFunction",
    value: function removeFunction(_ref0) {
      var functionId = _ref0.id;
      var functions = this.functions_;
      functions[functionId].destroy();
      delete functions[functionId];
      var functionType = "func_".concat(functionId);
      Entry.container.removeFuncBlocks(functionType);
      for (var id in functions) {
        functions[id].content.removeBlocksByType(functionType);
      }
      this.updateList();
    }
  }, {
    key: "removeNotPythonSupportedFunction",
    value: function removeNotPythonSupportedFunction() {
      var functions = this.functions_;
      Object.values(functions).forEach(function (func) {
        var isNotPythonSupport = func.useLocalVariables || func.type === 'value';
        if (isNotPythonSupport) {
          var functionId = func.id;
          func.destroy();
          delete functions[functionId];
          var functionType = "func_".concat(functionId);
          Entry.container.removeFuncBlocks(functionType);
          for (var id in functions) {
            functions[id].content.removeBlocksByType(functionType);
          }
        }
      });
      this.updateList();
    }
  }, {
    key: "checkListPosition",
    value: function checkListPosition(list, mouse) {
      var pos = {
        start_w: list.x_,
        area_w: list.x_ + list.width_,
        start_h: -list.y_,
        area_h: -list.y_ + -list.height_
      };
      if (mouse.x > pos.start_w && mouse.x < pos.area_w) {
        if (mouse.y < pos.start_h && mouse.y > pos.area_h) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "getListById",
    value: function getListById(mouseevt) {
      var lists = this.lists_;
      var returnList = [];
      if (lists.length > 0) {
        for (var i = 0; i < lists.length; i++) {
          if (this.checkListPosition(lists[i], mouseevt)) {
            returnList.push(lists[i]);
          }
        }
        return returnList;
      }
      return false;
    }
  }, {
    key: "_getVariableByName",
    value: function _getVariableByName(arr, variableName, isSelf, currentObjectId) {
      var object = _.result(Entry.playground, 'object');
      if (!currentObjectId && object) {
        currentObjectId = object.id;
      }
      for (var i = 0; i < arr.length; i++) {
        var v = arr[i];
        if (isSelf === true) {
          if (!v.object_ || v.object_ !== currentObjectId) {
            continue;
          }
        } else if (isSelf === false) {
          if (v.object_) {
            continue;
          }
        }
        if (v.getName() === variableName) {
          return v;
        }
      }
    }
  }, {
    key: "getVariableByName",
    value: function getVariableByName(variableName, isSelf, currentObjectId) {
      return this._getVariableByName(this.variables_, variableName, isSelf, currentObjectId);
    }
  }, {
    key: "getListByName",
    value: function getListByName(name, isSelf, currentObjectId) {
      return this._getVariableByName(this.lists_, name, isSelf, currentObjectId);
    }

    /**
     * Save variable
     * @param {Entry.Func} func
     */
  }, {
    key: "saveFunction",
    value: function saveFunction(func) {
      this.hasBlockInFunction.cache.clear();
      this.hasParamBlockInFunction.cache.clear();
      this.hasFuncBlockInFunction.cache.clear();
      /* add to function list when not exist */
      var ws = Entry.getMainWS();
      if (ws && ws.overlayModefrom == Entry.Workspace.MODE_VIMBOARD) {
        if (func && func.description) {
          var funcName = func.description.substring(1, func.description.length - 1);
          var alertMsg = Entry.TextCodingUtil.validateNameIncludeSpace(funcName, 'function');
          if (alertMsg) {
            Entry.modal.alert(alertMsg);
            Entry.Func.cancelEdit();
            return;
          }
        }
      }
      if (!this.functions_[func.id]) {
        this.functions_[func.id] = func;
        this.createFunctionView(func);
      }
      if (func.listElement) {
        func.listElement.nameField.textContent = func.description;
      }
      this.updateList();
    }

    /**
     * @param {Entry.Func} func
     */
  }, {
    key: "createFunctionView",
    value: function createFunctionView(func) {
      var _this13 = this;
      var createElement = Entry.createElement;
      var view = Entry.createElement('div').addClass('list default_func');
      var that = this;
      var editBoxWrapper = createElement('div').addClass('inpt_box').bindOnClick(function (e) {
        e.stopPropagation();
        if (!Entry.isTextMode) {
          if (Entry.Func.isEdit) {
            Entry.Func._backupContent = null;
            Entry.Func.save();
          }
          Entry["do"]('funcEditStart', func.id);
        }
        return _this13.select(func);
      }).appendTo(view);
      var editBoxInputWrapper = createElement('div').addClass('inpt').appendTo(editBoxWrapper);
      var editBoxInput = createElement('span').addClass('input').appendTo(editBoxInputWrapper);
      editBoxInput.textContent = func.description;
      editBoxInput.setAttribute('autocomplete', 'off');
      var ArrowDownButton = createElement('div').addClass('arrowDown').appendTo(editBoxWrapper);
      var delButton = createElement('a').addClass('del').bindOnClick(function (e) {
        e.stopPropagation();
        Entry.modal.confirm(Lang.Workspace.will_you_delete_function).then(function (result) {
          if (result === true) {
            _this13.destroyFunction(func);
            _this13.selected = null;
          }
        });
      }).appendTo(editBoxWrapper);
      delButton.href = '#';
      view.nameField = editBoxInput;
      func.listElement = view;
    }
  }, {
    key: "destroyFunction",
    value: function () {
      var _destroyFunction = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(func) {
        var currentObjectId, functionType;
        return _regenerator["default"].wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (Entry.Func.targetFunc) {
                Entry["do"]('funcEditEnd', 'cancel');
              }
              currentObjectId = Entry.playground.object.id;
              Entry["do"]('selectObject', currentObjectId);
              functionType = "func_".concat(func.id);
              _context4.next = 1;
              return Entry.Utils.removeBlockByTypeAsync(functionType);
            case 1:
              Entry["do"]('funcRemove', func).isPass(true);
              Entry["do"]('selectObject', currentObjectId).isPass(true);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function destroyFunction(_x4) {
        return _destroyFunction.apply(this, arguments);
      }
      return destroyFunction;
    }()
    /**
     * Add variable
     * @param {Entry.Variable} variable
     * @return {boolean} return true when success
     */
  }, {
    key: "checkAllVariableName",
    value: function checkAllVariableName(name, variable) {
      var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name_';
      return this[variable].some(function (_ref1) {
        var name_ = _ref1[key];
        return name_ === name;
      });
    }
  }, {
    key: "_addVariableOrList",
    value: function _addVariableOrList(type, data) {
      if (!type) {
        return;
      }
      var panel = this._getAddPanel(type);
      var name = panel.view.name.value.trim();
      if (Entry.isTextMode) {
        var alertMsg = Entry.TextCodingUtil.validateNameIncludeSpace(name, type);
        if (alertMsg) {
          Entry.modal.alert(alertMsg);
          this.resetVariableAddPanel(type);
          return;
        }
      }
      var target = "".concat(type, "s_");
      data = data || this._makeVariableData(type);
      this.resetVariableAddPanel(type);
      if (!(data instanceof Entry.Variable)) {
        data = Entry.Variable.create(data);
      }
      if (type === 'variable') {
        this.createVariableView(data);
      } else {
        this.createListView(data);
      }
      data.generateView(this[target].length);
      this[target].unshift(data);
      var playground = Entry.playground;
      if (playground) {
        var blockMenu = playground.blockMenu;
        if (blockMenu) {
          blockMenu.deleteRendered('variable');
        }
        playground.reloadPlayground();
      }
      this.select(data);
      this.updateList();
    }
  }, {
    key: "addVariable",
    value: function addVariable(variable) {
      this._addVariableOrList.call(this, 'variable', variable);
    }

    /**
     * Remove variable
     * @param {Entry.Variable} variable
     */
  }, {
    key: "removeVariable",
    value: function removeVariable(variable) {
      if (!(variable instanceof Entry.Variable)) {
        variable = this.getVariable(variable.id);
      }
      if (this.selected == variable) {
        this.select(null);
      }
      variable.remove();
      var variables = this.variables_;
      variables.splice(variables.indexOf(variable), 1);
      Entry.playground.reloadPlayground();
      this.updateList();
    }

    /**
     * @param {Entry.Variable} variable
     * @param {String} name
     */
  }, {
    key: "changeVariableName",
    value: function changeVariableName(variable, name) {
      if (variable.name_ == name) {
        return;
      }
      if (Entry.isTextMode) {
        var alertMsg = Entry.TextCodingUtil.validateNameIncludeSpace(name, 'variable');
        if (alertMsg) {
          Entry.modal.alert(alertMsg);
          variable.listElement.nameField.value = variable.name_;
          return;
        }
      }
      if (Entry.isExist(name, 'name_', this.variables_)) {
        return this.changeVariableNameDuplicated(variable, 'variable', name);
      } else if (name.length > 10) {
        variable.listElement.nameField.value = variable.name_;
        return Entry.toast.alert(Lang.Workspace.variable_rename_failed, Lang.Workspace.variable_too_long);
      }
      variable.setName(name);
      variable.listElement.nameField.value = name;
      Entry.playground.reloadPlayground();
      Entry.toast.success(Lang.Workspace.variable_rename, Lang.Workspace.variable_rename_ok);
    }

    /**
     * @param {Entry.Variable} list
     * @param {String} name
     */
  }, {
    key: "changeListName",
    value: function changeListName(list, name) {
      if (list.name_ == name) {
        return;
      }
      if (Entry.isTextMode) {
        var alertMsg = Entry.TextCodingUtil.validateNameIncludeSpace(name, 'list');
        if (alertMsg) {
          Entry.modal.alert(alertMsg);
          list.listElement.nameField.value = list.name_;
          return;
        }
      }
      if (Entry.isExist(name, 'name_', this.lists_)) {
        return this.changeVariableNameDuplicated(list, 'list', name);
      } else if (name.length > 10) {
        Entry.toast.alert(Lang.Workspace.list_rename_failed, Lang.Workspace.list_too_long);
      } else {
        //name successfully changed
        list.name_ = name;
        list.updateView();
        Entry.playground.reloadPlayground();
        Entry.toast.success(Lang.Workspace.list_rename, Lang.Workspace.list_rename_ok);
      }
      list.listElement.nameField.value = list.name_;
    }

    /**
     * @param {Entry.Variable} variable or list
     * @param {string} type [variable, list]
     * @param {string} name
     */
  }, {
    key: "changeVariableNameDuplicated",
    value: function changeVariableNameDuplicated(variable, type, name) {
      var variables = this["".concat(type, "s_")].filter(function (_ref10) {
        var id_ = _ref10.id_;
        return id_ !== variable.id_;
      });
      var newName = Entry.getOrderedName(this._truncName(name, type, this._maxNameLength), variables, 'name_');
      variable.setName(newName);
      variable.listElement.nameField.value = newName;
      Entry.playground.reloadPlayground();
      Entry.toast.warning(Lang.Workspace["".concat(type, "_rename")], Lang.Workspace["".concat(type, "_dup")]);
    }

    /**
     * Remove list
     * @param {Entry.Variable} list
     */
  }, {
    key: "removeList",
    value: function removeList(list) {
      if (!(list instanceof Entry.Variable)) {
        list = this.getList(list.id);
      }
      if (this.selected == list) {
        this.select(null);
      }
      list.remove();
      var lists = this.lists_;
      lists.splice(lists.indexOf(list), 1);
      Entry.playground.reloadPlayground();
      this.updateList();
    }

    /**
     * @param {Entry.Variable} variable
     */
  }, {
    key: "createVariableView",
    value: function createVariableView(variable) {
      var that = this;
      var createElement = Entry.createElement;
      var variableWrapper = createElement('div').addClass('list fold');
      if (!variable.object_) {
        if (variable.isCloud_) {
          variableWrapper.addClass('cloud_variable');
        } else if (variable.isRealTime_) {
          variableWrapper.addClass('real_time_variable');
        } else {
          variableWrapper.addClass('default_val');
        }
      } else {
        variableWrapper.addClass('local_val');
      }
      var editBoxWrapper = createElement('div').addClass('inpt_box').bindOnClick(function (e) {
        e.stopPropagation();
        if (that.variableSettingView) {
          $(that.variableSettingView).remove();
          delete that.variableSettingView;
        }
        if (that.selected === variable) {
          if (!that._isPythonMode()) {
            editBoxInput.blur();
          }
          that.select(variable);
          that.updateSelectedVariable(null, 'variable');
        } else {
          Entry["do"]('setVariableEditable', variable.id_);
        }
      }).appendTo(variableWrapper);
      var watchButton = createElement('a').addClass('watch').bindOnClick(function (e) {
        e.stopPropagation();
        Entry["do"]('variableSetVisibility', variable.id_, !variable.isVisible());
        if (variable.isVisible()) {
          watchButton.addClass('on');
        } else {
          watchButton.removeClass('on');
        }
      }).appendTo(editBoxWrapper);
      if (variable.isVisible()) {
        watchButton.addClass('on');
      } else {
        watchButton.removeClass('on');
      }
      watchButton.href = '#';
      var editBoxInputWrapper = createElement('div').addClass('inpt').appendTo(editBoxWrapper);
      var editBoxInput = createElement('input').addClass('editBoxInput').bindOnClick(function (e) {
        e.stopPropagation();
      }).appendTo(editBoxInputWrapper);
      editBoxInput.setAttribute('autocomplete', 'off');
      editBoxInput.setAttribute('type', 'text');
      editBoxInput.setAttribute('name', 'inpt_name');
      editBoxInput.value = variable.name_;
      editBoxInput.onblur = function () {
        var value = this.value.trim();
        if (!value) {
          Entry.toast.alert(Lang.Msgs.warn, Lang.Msgs.variable_can_not_space);
          this.value = variable.getName();
          return this.focus();
        }
        var targetVariable = that.getVariable(variable.getId());
        targetVariable && Entry["do"]('variableSetName', targetVariable.getId(), value);
      };
      editBoxInput.onkeydown = Entry.Utils.blurWhenEnter;
      var ArrowDownButton = createElement('div').addClass('arrowDown').appendTo(editBoxWrapper);
      var delButton = createElement('a').addClass('del').bindOnClick(function (e) {
        e.stopPropagation();
        Entry["do"]('variableContainerRemoveVariable', variable);
      }).appendTo(editBoxWrapper);
      delButton.href = '#';
      variableWrapper.nameField = editBoxInput;
      variable.listElement = variableWrapper;
    }

    /**
     * Add event for block
     * @param {message model} message
     * @return {boolean} return true when success
     */
  }, {
    key: "addMessage",
    value: function addMessage() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var messages = this.messages_;
      if (!message.name) {
        message.name = "".concat(Lang.Workspace.message, " ").concat(messages.length + 1);
      }
      if (!message.id) {
        message.id = Entry.generateHash();
      }
      this.createMessageView(message);
      messages.unshift(message);
      var _Entry = Entry,
        playground = _Entry.playground;
      if (playground) {
        var blockMenu = playground.blockMenu;
        if (blockMenu) {
          blockMenu.deleteRendered('start');
        }
        playground.reloadPlayground();
      }
      this.updateList();
      var nameField = message.listElement.nameField;

      //flag for first time blur command
      //focus first and value not changed
      //command will be skipped
      nameField.isFirst = true;
    }

    /**
     * Add event
     * @param {message model} message
     */
  }, {
    key: "removeMessage",
    value: function removeMessage(_ref11) {
      var id = _ref11.id;
      var message = this.getMessage(id);
      if (this.selected == message) {
        this.select(null);
      }
      var messages_ = this.messages_;
      messages_.splice(messages_.indexOf(message), 1);
      this.updateList();
      Entry.playground.reloadPlayground();
    }

    /**
     * @param {object} message
     * @param {String} name
     */
  }, {
    key: "changeMessageName",
    value: function changeMessageName(_ref12, name) {
      var id = _ref12.id;
      var message = this.getMessage(id);
      if (message.name == name) {
        return;
      }
      var messages = this.messages_;
      var exist = Entry.isExist(name, 'name', messages);
      var nameField = message.listElement.nameField;
      var _Entry2 = Entry,
        playground = _Entry2.playground,
        toast = _Entry2.toast;
      if (exist) {
        return failFunc(message.name, Lang.Workspace.message_rename_failed, Lang.Workspace.message_dup);
      } else if (name.length > EntryStatic.messageMaxLength) {
        return failFunc(message.name, Lang.Workspace.message_rename_failed, Lang.Workspace.message_too_long_to_change);
      }
      message.name = name;
      nameField.value = message.name;
      if (playground) {
        playground.blockMenu.deleteRendered('start');
        playground.reloadPlayground();
      }
      toast.success(Lang.Workspace.message_rename, Lang.Workspace.message_rename_ok);
      function failFunc(value, title, message) {
        nameField.value = value;
        return toast.alert(title, message);
      }
    }
  }, {
    key: "activateMessageEditView",
    value: function activateMessageEditView(message) {
      $(message.listElement).find('.entryVariableListElementNameWorkspace').removeAttr('disabled').focus();
    }

    /**
     * @param {object} message
     */
  }, {
    key: "createMessageView",
    value: function createMessageView(message) {
      var _this14 = this;
      var createElement = Entry.createElement;
      var view = Entry.createElement('div').addClass('list default_message');
      var editBoxWrapper = createElement('div').addClass('inpt_box').bindOnClick(function (e) {
        e.stopPropagation();
        return _this14.select(message);
      }).appendTo(view);
      var editBoxInputWrapper = createElement('div').addClass('inpt').appendTo(editBoxWrapper);
      var editBoxInput = createElement('input').addClass('editBoxInput').bindOnClick(function (e) {
        e.stopPropagation();
      }).appendTo(editBoxInputWrapper);
      editBoxInput.setAttribute('autocomplete', 'off');
      editBoxInput.setAttribute('type', 'text');
      editBoxInput.value = message.name;
      editBoxInput.onfocus = Entry.Utils.setFocused;
      editBoxInput.onblur = Entry.Utils.setBlurredTimer(function () {
        var value = this.value;
        if (!value.trim()) {
          Entry.toast.alert(Lang.Msgs.warn, Lang.Msgs.sign_can_not_space);
          this.value = message.name;
          return this.focus();
        }

        //check message exist currently
        message = Entry.variableContainer.getMessage(message.id);
        if (message && !(this.isFirst && value === message.name)) {
          Entry["do"]('messageSetName', message.id, value);
        }
        delete this.isFirst;
      }, 200);
      editBoxInput.onkeydown = Entry.Utils.blurWhenEnter;
      var ArrowDownButton = createElement('div').addClass('arrowDown').appendTo(editBoxWrapper);
      var delButton = createElement('a').addClass('del').bindOnClick(function (e) {
        e.stopPropagation();
        Entry["do"]('variableContainerRemoveMessage', message);
      }).appendTo(editBoxWrapper);
      delButton.href = '#';
      view.nameField = editBoxInput;
      message.listElement = view;
    }

    /**
     * Add list for block
     * @param {list model} list
     * @return {boolean} return true when success
     */
  }, {
    key: "addList",
    value: function addList(list) {
      this._addVariableOrList.call(this, 'list', list);
    }

    /**
     * @param {Entry.Variable} list
     */
  }, {
    key: "createListView",
    value: function createListView(list) {
      var that = this;
      var createElement = Entry.createElement;
      var listWrapper = createElement('div').addClass('list fold').appendTo(this.globalListBox);
      if (!list.object_) {
        if (list.isCloud_) {
          listWrapper.addClass('cloud_list');
        } else if (list.isRealTime_) {
          listWrapper.addClass('real_time_list');
        } else {
          listWrapper.addClass('default_list');
        }
      } else {
        listWrapper.addClass('local_list');
      }
      var editBoxWrapper = createElement('div').addClass('inpt_box').bindOnClick(function (e) {
        e.stopPropagation();
        if (that.listSettingView) {
          $(that.listSettingView).remove();
          delete that.listSettingView;
        }
        if (that.selected === list) {
          editBoxInput.blur();
          that.select(list);
          that.updateSelectedVariable(null, 'list');
        } else {
          Entry["do"]('setListEditable', list.id_);
        }
      }).appendTo(listWrapper);
      var watchButton = createElement('a').addClass('watch').bindOnClick(function (e) {
        e.stopPropagation();
        Entry["do"]('listSetVisibility', list.id_, !list.isVisible());
        if (list.isVisible()) {
          watchButton.addClass('on');
        } else {
          watchButton.removeClass('on');
        }
      }).appendTo(editBoxWrapper);
      if (list.isVisible()) {
        watchButton.addClass('on');
      } else {
        watchButton.removeClass('on');
      }
      watchButton.href = '#';
      var editBoxInputWrapper = createElement('div').addClass('inpt').appendTo(editBoxWrapper);
      var editBoxInput = createElement('input').addClass('editBoxInput').bindOnClick(function (e) {
        e.stopPropagation();
      }).appendTo(editBoxInputWrapper);
      editBoxInput.setAttribute('autocomplete', 'off');
      editBoxInput.setAttribute('type', 'text');
      editBoxInput.setAttribute('name', 'inpt_name');
      editBoxInput.value = list.name_;
      editBoxInput.onblur = function () {
        var value = this.value.trim();
        if (!value) {
          Entry.toast.alert(Lang.Msgs.warn, Lang.Msgs.list_can_not_space);
          this.value = list.getName();
          return this.focus();
        }
        var targetList = that.getList(list.getId());
        targetList && Entry["do"]('listSetName', targetList.getId(), value);
      };
      editBoxInput.onkeydown = Entry.Utils.blurWhenEnter;
      var ArrowDownButton = createElement('div').addClass('arrowDown').appendTo(editBoxWrapper);
      var delButton = createElement('a').addClass('del').bindOnClick(function (e) {
        e.stopPropagation();
        Entry["do"]('variableContainerRemoveList', list);
      }).appendTo(editBoxWrapper);
      delButton.href = '#';
      listWrapper.nameField = editBoxInput;
      list.listElement = listWrapper;
    }

    /**
     * Apply map function to variables. But this not replace object with returned one.
     * So giving map function don't have to return object.
     * And this support another arguments.
     * @param {!function} mapFunction
     * @param {} param
     */
  }, {
    key: "mapVariable",
    value: function mapVariable(mapFunction, param) {
      this.variables_.forEach(_.partial(mapFunction, _, param));
    }

    /**
     * @param {!function} mapFunction
     * @param {} param
     */
  }, {
    key: "mapList",
    value: function mapList(mapFunction, param) {
      this.lists_.forEach(_.partial(mapFunction, _, param));
    }
  }, {
    key: "mapFunc",
    value: function mapFunc(mapFunction, param) {
      Object.values(this.functions_).forEach(_.partial(mapFunction, _, param));
    }

    /**
     * convert this variable's data to JSON.
     * @return {JSON}
     */
  }, {
    key: "getVariableJSON",
    value: function getVariableJSON() {
      return [].concat((0, _toConsumableArray2["default"])(this.variables_), (0, _toConsumableArray2["default"])(this.lists_), [_.result(Entry.engine, 'projectTimer'), _.result(Entry.container, 'inputValue')]).filter(_.identity).map(function (v) {
        return v.toJSON ? v.toJSON() : v;
      });
    }

    /**
     * convert this message's data to JSON.
     * @return {JSON}
     */
  }, {
    key: "getMessageJSON",
    value: function getMessageJSON() {
      return this.messages_.map(_.partial(_.pick, _, 'id', 'name'));
    }

    /**
     * convert this function's data to JSON.
     * @return {JSON}
     */
  }, {
    key: "getFunctionJSON",
    value: function getFunctionJSON() {
      return _.reduce(this.functions_, function (acc, _ref13) {
        var id = _ref13.id,
          content = _ref13.content,
          _ref13$type = _ref13.type,
          type = _ref13$type === void 0 ? 'normal' : _ref13$type,
          useLocalVariables = _ref13.useLocalVariables,
          localVariables = _ref13.localVariables;
        return [].concat((0, _toConsumableArray2["default"])(acc), [{
          id: id,
          type: type,
          localVariables: localVariables,
          useLocalVariables: useLocalVariables,
          content: content.stringify()
        }]);
      }, []);
    }
  }, {
    key: "resetVariableAddPanel",
    value: function resetVariableAddPanel() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'variable';
      var panel = this._getAddPanel(type);
      if (!panel.view) {
        return;
      }
      var info = panel.info;
      info.isCloud = false;
      info.isRealTime = false;
      info.object = null;
      panel.view.name.value = '';
      panel.isOpen = false;
      this.updateVariableAddView(type);
    }
  }, {
    key: "generateVariableAddView",
    value: function generateVariableAddView() {
      var _this15 = this;
      var createElement = Entry.createElement;
      var _whenEnter = Entry.Utils.whenEnter;
      var _setFocused = Entry.Utils.setFocused;
      var _setBlurredTimer = Entry.Utils.setBlurredTimer;
      var that = this;

      // 변수 만들기 폼
      var variableAddSpace = createElement('div').addClass('entryVariableAddSpaceWorkspace off');
      this.variableAddPanel.view = variableAddSpace;
      this.variableAddPanel.isOpen = false;
      var variableAddSpaceDataWrapper = createElement('div').addClass('entryVariableAddSpaceDataWrapperWorkspace').appendTo(variableAddSpace);

      // 입력 폼
      var addSpaceNameWrapper = createElement('div').addClass('entryVariableAddSpaceNameWrapperWorkspace').appendTo(variableAddSpaceDataWrapper);
      var addSpaceInputLabel = createElement('label').addClass('entryVariableAddSpaceInputLabelWorkspace').appendTo(addSpaceNameWrapper);
      addSpaceInputLabel.setAttribute('for', 'entryVariableAddSpaceInputWorkspace');
      addSpaceInputLabel.innerText = Lang.Workspace.Variable_placeholder_name;
      var addSpaceInput = createElement('input').addClass('entryVariableAddSpaceInputWorkspace').appendTo(addSpaceNameWrapper);
      addSpaceInput.setAttribute('autocomplete', 'off');
      addSpaceInput.setAttribute('type', 'text');
      addSpaceInput.id = 'entryVariableAddSpaceInputWorkspace';
      addSpaceInput.setAttribute('placeholder', Lang.Workspace.Variable_placeholder_content);
      addSpaceInput.variableContainer = this;
      addSpaceInput.onkeypress = _whenEnter(function () {
        if (this.enterKeyDisabled) {
          this.blur();
        } else {
          that._addVariable();
        }
      });
      addSpaceInput.onfocus = _setFocused;
      var doBlur = _setBlurredTimer(function () {
        this.isBlurred = false;
        Entry["do"]('variableAddSetName', this.value);
        this.blurCallback && this.blurCallback();
      });
      addSpaceInput.onblur = function () {
        _this15.isBlurred = true;
        doBlur.apply(_this15);
      };
      this.variableAddPanel.view.name = addSpaceInput;
      var addSpaceSelectWrapper = createElement('div').addClass('entryVariableAddSpaceSelectWrapperWorkspace').appendTo(variableAddSpaceDataWrapper);
      var addSpaceGlobalButton = createElement('a').addClass('button entryVariableAddSpaceGlobalButtonrWorkspace on').bindOnClick(function () {
        addSpaceLocalButton.removeClass('on');
        addSpaceGlobalButton.addClass('on');
        variableTypeWrapper.addClass('on');
        return Entry["do"]('variableAddSetScope', 'global');
      }).appendTo(addSpaceSelectWrapper);
      addSpaceGlobalButton.textContent = Lang.Workspace.use_all_objects;
      this.variableAddPanel.view.globalCheck = addSpaceGlobalButton;
      var addSpaceLocalButton = createElement('a').addClass('button entryVariableAddSpaceLocalButtonrWorkspace').bindOnClick(function () {
        addSpaceGlobalButton.removeClass('on');
        addSpaceLocalButton.addClass('on');
        variableTypeWrapper.removeClass('on');
        return Entry["do"]('variableAddSetScope', 'local');
      }).appendTo(addSpaceSelectWrapper);
      addSpaceLocalButton.textContent = Lang.Workspace.Variable_use_this_object;
      this.variableAddPanel.view.localCheck = addSpaceLocalButton;
      var variableTypeWrapper = createElement('div').addClass('entryVariableTypeBoxWrapper on').appendTo(variableAddSpaceDataWrapper);
      ['normal', 'cloud', 'real_time'].forEach(function (type) {
        var wrapper = createElement('div').addClass("entryVariableTypeWrapper").appendTo(variableTypeWrapper).bindOnClick(function (e) {
          e.stopImmediatePropagation();
          var _this15$variableAddPa = _this15.variableAddPanel.info,
            object = _this15$variableAddPa.object,
            isCloud = _this15$variableAddPa.isCloud,
            isRealTime = _this15$variableAddPa.isRealTime;
          !object && Entry["do"]('variableAddSetCloud', type);
          _assertClassBrand(_VariableContainer_brand, _this15, _removeChildrenClass).call(_this15, variableTypeWrapper, 'on');
          wrapper.addClass('on');
        });
        if (type === 'normal') {
          wrapper.addClass('on');
        }
        createElement('span').addClass("entryVariable".concat(type, "RadioButton radioButton")).appendTo(wrapper);
        createElement('span').addClass("entryVariable".concat(type, "Text"), 'entryVariableAddSpaceCheckWorkspace').appendTo(wrapper).textContent = Lang.Workspace["variable_create_".concat(type)];
      });
      variableAddSpace.cloudWrapper = variableTypeWrapper;
      this.variableAddPanel.view.cloudCheck = variableTypeWrapper;

      // 확인 취소 버튼
      var addSpaceButtonWrapper = createElement('div').addClass('entryVariableAddSpaceButtonWrapperWorkspace').appendTo(variableAddSpace);
      var addSpaceCancelButton = createElement('a').addClass('entryVariableAddSpaceCancelWorkspace').addClass('entryVariableAddSpaceButtonWorkspace').bindOnClick(function () {
        _this15.variableAddPanel.view.addClass('off');
        _this15.resetVariableAddPanel('variable');
      }).appendTo(addSpaceButtonWrapper);
      addSpaceCancelButton.href = '#';
      addSpaceCancelButton.textContent = Lang.Buttons.cancel;
      var addSpaceConfirmButton = createElement('a').addClass('entryVariableAddSpaceConfirmWorkspace').addClass('entryVariableAddSpaceButtonWorkspace').bindOnClick(function () {
        that._addVariable();
      }).appendTo(addSpaceButtonWrapper);
      addSpaceConfirmButton.textContent = Lang.Buttons.add_variable;
      this.variableAddConfirmButton = addSpaceConfirmButton;
    }
  }, {
    key: "_addVariable",
    value: function _addVariable() {
      var _this16 = this;
      var variableInput = Entry.getDom(['variableContainer', 'variableAddInput']);
      this.variableAddPanel.view.addClass('off');
      var blurCallback = function blurCallback() {
        delete variableInput.blurCallback;
        Entry["do"]('variableContainerAddVariable', Entry.Variable.create(_this16._makeVariableData('variable')));
        var _this16$variables_ = (0, _slicedToArray2["default"])(_this16.variables_, 1),
          variable = _this16$variables_[0];
        _this16.updateSelectedVariable(variable);
        var nameField = variable.listElement.nameField;
        nameField.removeAttribute('disabled');
      };
      if (variableInput.isBlurred) {
        variableInput.blurCallback = blurCallback;
      } else {
        blurCallback();
      }
      this.resetVariableAddPanel('variable');
    }
  }, {
    key: "_addList",
    value: function _addList() {
      var _this17 = this;
      var listInput = Entry.getDom(['variableContainer', 'listAddInput']);
      this.listAddPanel.view.addClass('off');
      var blurCallback = function blurCallback() {
        Entry["do"]('variableContainerAddList', Entry.Variable.create(_this17._makeVariableData('list')));
        var _this17$lists_ = (0, _slicedToArray2["default"])(_this17.lists_, 1),
          list = _this17$lists_[0];
        _this17.updateSelectedVariable(list);
        var nameField = list.listElement.nameField;
        nameField.removeAttribute('disabled');
      };
      if (listInput.isBlurred) {
        listInput.blurCallback = blurCallback;
      } else {
        blurCallback();
      }
      this.resetVariableAddPanel('list');
    }
  }, {
    key: "generateListAddView",
    value: function generateListAddView() {
      var _this18 = this;
      var createElement = Entry.createElement;
      var _setFocused = Entry.Utils.setFocused;
      var _setBlurredTimer = Entry.Utils.setBlurredTimer;
      var that = this;

      // 리스트 만들기 폼
      var listAddSpace = createElement('div').addClass('entryVariableAddSpaceWorkspace off');
      this.listAddPanel.view = listAddSpace;
      this.listAddPanel.isOpen = false;
      var variableAddSpaceDataWrapper = createElement('div').addClass('entryVariableAddSpaceDataWrapperWorkspace').appendTo(listAddSpace);

      // 리스트 만들기
      var addSpaceNameWrapper = createElement('div').addClass('entryVariableAddSpaceNameWrapperWorkspace').appendTo(variableAddSpaceDataWrapper);
      var addSpaceInputLabel = createElement('label').addClass('entryVariableAddSpaceInputLabelWorkspace').appendTo(addSpaceNameWrapper);
      addSpaceInputLabel.innerText = Lang.Workspace.list_name;
      addSpaceInputLabel.setAttribute('for', 'entryVariableAddSpaceInputWorkspace');
      var addSpaceInput = createElement('input').addClass('entryVariableAddSpaceInputWorkspace').appendTo(addSpaceNameWrapper);
      addSpaceInput.setAttribute('autocomplete', 'off');
      addSpaceInput.setAttribute('type', 'text');
      addSpaceInput.id = 'entryVariableAddSpaceInputWorkspace';
      addSpaceInput.setAttribute('placeholder', Lang.Workspace.list_create_placeholder);
      addSpaceInput.onkeypress = Entry.Utils.whenEnter(function () {
        if (this.enterKeyDisabled) {
          this.blur();
        } else {
          that._addList();
        }
      });
      addSpaceInput.onfocus = _setFocused;
      var doBlur = _setBlurredTimer(function () {
        this.isBlurred = false;
        Entry["do"]('listAddSetName', this.value);
        this.blurCallback && this.blurCallback();
      });
      addSpaceInput.onblur = function () {
        _this18.isBlurred = true;
        doBlur.apply(_this18);
      };
      this.listAddPanel.view.name = addSpaceInput;
      var addSpaceSelectWrapper = createElement('div').addClass('entryVariableAddSpaceSelectWrapperWorkspace').appendTo(variableAddSpaceDataWrapper);
      var addSpaceGlobalButton = createElement('a').addClass('button entryVariableAddSpaceGlobalButtonrWorkspace on').bindOnClick(function () {
        addSpaceLocalButton.removeClass('on');
        addSpaceGlobalButton.addClass('on');
        variableTypeWrapper.addClass('on');
        return Entry["do"]('listAddSetScope', 'global');
      }).appendTo(addSpaceSelectWrapper);
      addSpaceGlobalButton.textContent = Lang.Workspace.use_all_objects;
      this.listAddPanel.view.globalCheck = addSpaceGlobalButton;
      var addSpaceLocalButton = createElement('a').addClass('button entryVariableAddSpaceLocalButtonrWorkspace').bindOnClick(function () {
        addSpaceGlobalButton.removeClass('on');
        addSpaceLocalButton.addClass('on');
        variableTypeWrapper.removeClass('on');
        return Entry["do"]('listAddSetScope', 'local');
      }).appendTo(addSpaceSelectWrapper);
      addSpaceLocalButton.textContent = Lang.Workspace.Variable_use_this_object;
      this.listAddPanel.view.localCheck = addSpaceLocalButton;
      var variableTypeWrapper = createElement('div').addClass('entryVariableTypeBoxWrapper on').appendTo(variableAddSpaceDataWrapper);
      ['normal', 'cloud', 'real_time'].forEach(function (type) {
        var wrapper = createElement('div').addClass("entryVariableTypeWrapper").appendTo(variableTypeWrapper).bindOnClick(function (e) {
          e.stopImmediatePropagation();
          var object = _this18.listAddPanel.info.object;
          !object && Entry["do"]('listAddSetCloud', type);
          _assertClassBrand(_VariableContainer_brand, _this18, _removeChildrenClass).call(_this18, variableTypeWrapper, 'on');
          wrapper.addClass('on');
        });
        if (type === 'normal') {
          wrapper.addClass('on');
        }
        createElement('span').addClass("entryVariable".concat(type, "RadioButton radioButton")).appendTo(wrapper);
        createElement('span').addClass("entryVariable".concat(type, "Text"), 'entryVariableAddSpaceCheckWorkspace').appendTo(wrapper).textContent = Lang.Workspace["list_create_".concat(type)];
      });
      listAddSpace.cloudWrapper = variableTypeWrapper;
      this.listAddPanel.view.cloudCheck = variableTypeWrapper;

      // 확인 취소 버튼
      var addSpaceButtonWrapper = createElement('div').addClass('entryVariableAddSpaceButtonWrapperWorkspace').appendTo(listAddSpace);
      var addSpaceCancelButton = createElement('a').addClass('entryVariableAddSpaceCancelWorkspace').addClass('entryVariableAddSpaceButtonWorkspace').bindOnClick(function () {
        _this18.listAddPanel.view.addClass('off');
        _this18.resetVariableAddPanel('list');
      }).appendTo(addSpaceButtonWrapper);
      addSpaceCancelButton.href = '#';
      addSpaceCancelButton.textContent = Lang.Buttons.cancel;
      var addSpaceConfirmButton = createElement('a').addClass('entryVariableAddSpaceConfirmWorkspace').addClass('entryVariableAddSpaceButtonWorkspace').bindOnClick(function () {
        that._addList();
      }).appendTo(addSpaceButtonWrapper);
      addSpaceConfirmButton.href = '#';
      addSpaceConfirmButton.textContent = Lang.Buttons.add_list;
      this.listAddConfirmButton = addSpaceConfirmButton;
    }
  }, {
    key: "generateMessageAddView",
    value: function generateMessageAddView() {
      var _this19 = this;
      var createElement = Entry.createElement;
      var that = this;

      // 신호 만들기 폼
      var msgAddSpace = createElement('div').addClass('message_inpt off');
      this.messageAddPanel.view = msgAddSpace;
      this.messageAddPanel.isOpen = false;
      var msdAddSpaceWrapper = createElement('div').addClass('msdAddSpaceWrapper').appendTo(msgAddSpace);
      var boxSubject = Entry.createElement('span').addClass('box_sjt').appendTo(msdAddSpaceWrapper);
      boxSubject.textContent = Lang.Workspace.Message_placeholder_name;
      var msgNameInput = createElement('input').appendTo(msdAddSpaceWrapper);
      msgNameInput.setAttribute('autocomplete', 'off');
      msgNameInput.setAttribute('type', 'text');
      msgNameInput.setAttribute('placeholder', Lang.Workspace.message_create_placeholder);
      msgNameInput.onkeydown = Entry.Utils.whenEnter(function () {
        if (this.enterKeyDisabled) {
          this.blur();
        } else {
          var value = msgNameInput.value;
          if (value.length > EntryStatic.messageMaxLength) {
            return Entry.toast.alert(Lang.Workspace.message_add_fail, Lang.Workspace.message_too_long);
          }
          that.messageAddPanel.isOpen = false;
          msgAddSpace.addClass('off');
          msgNameInput.value = '';
          Entry["do"]('variableContainerAddMessage', {
            id: Entry.generateHash(),
            name: Entry.getOrderedName(value || Lang.Workspace.message, that.messages_, 'name')
          });
        }
      });
      this.messageAddPanel.view.name = msgNameInput;
      var buttonWrapper = createElement('div').addClass('entryVariableAddSpaceButtonWrapperWorkspace').appendTo(msgAddSpace);
      var msgCancel = createElement('a').addClass('entryVariableAddSpaceCancelWorkspace').addClass('entryVariableAddSpaceButtonWorkspace').bindOnClick(function () {
        msgAddSpace.addClass('off');
        msgNameInput.value = '';
        _this19.messageAddPanel.isOpen = false;
      }).appendTo(buttonWrapper);
      msgCancel.href = '#';
      msgCancel.textContent = Lang.Buttons.cancel;
      var msgConfirm = createElement('a').addClass('entryVariableAddSpaceConfirmWorkspace').addClass('entryVariableAddSpaceButtonWorkspace').bindOnClick(function () {
        var value = msgNameInput.value;
        if (value.length > EntryStatic.messageMaxLength) {
          return Entry.toast.alert(Lang.Workspace.message_add_fail, Lang.Workspace.message_too_long);
        }
        _this19.messageAddPanel.isOpen = false;
        msgAddSpace.addClass('off');
        msgNameInput.value = '';
        Entry["do"]('variableContainerAddMessage', {
          id: Entry.generateHash(),
          name: Entry.getOrderedName(value || Lang.Workspace.message, _this19.messages_, 'name')
        });
      }).appendTo(buttonWrapper);
      msgConfirm.href = '#';
      msgConfirm.textContent = Lang.Buttons.add_message;
      msgAddSpace.nameField = msgNameInput;
    }

    /**
     * 자료형 블록메뉴에서 변수, 리스트 추가 버튼 클릭시 발생하는 함수
     * 패널을 속성탭으로 옮기고 해당 타입의 컨테이너를 오픈한다.
     * @param type {'variable'|'list'|'message'}
     */
  }, {
    key: "openVariableAddPanel",
    value: function openVariableAddPanel() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'variable';
      Entry.playground.toggleOnVariableView();
      Entry.playground.changeViewMode('variable');
      switch (type) {
        case 'variable':
          this.selectFilter(type);
          this.updateVariableAddView(type);
          this.clickVariableAddButton(true);
          break;
        case 'list':
          this.selectFilter(type);
          this.updateVariableAddView(type);
          this.clickListAddButton(true);
          break;
        case 'message':
          this.selectFilter(type);
          this.clickMessageAddButton(true);
          break;
      }
    }
  }, {
    key: "addCloneLocalVariables",
    value: function addCloneLocalVariables(param) {
      var that = this;

      //variables
      this.variables_.reduce(function (acc, variable) {
        var cloned = clone(variable, param, 'variables_');
        cloned && acc.push(cloned);
        return acc;
      }, []).forEach(this.addVariable.bind(this));

      //lists
      this.lists_.reduce(function (acc, list) {
        var cloned = clone(list, param, 'lists_');
        cloned && acc.push(cloned);
        return acc;
      }, []).forEach(this.addList.bind(this));
      function clone(variable, param, nameSpace) {
        //not a local variable
        var _object = variable.object_;
        if (!_object || _object !== param.objectId) {
          return;
        }
        var cloned = variable.toJSON();
        cloned.originId = cloned.id;
        cloned.id = Entry.generateHash();
        cloned.object = param.newObjectId;
        cloned.name = that.checkAllVariableName(cloned.name, nameSpace) ? Entry.getOrderedName(cloned.name, that[nameSpace], 'name_') : cloned.name;
        delete cloned.x;
        delete cloned.y;
        var json = param.json;
        json.script = json.script.replace(new RegExp(cloned.originId, 'g'), cloned.id);
        return cloned;
      }
    }
  }, {
    key: "generateTimer",
    value: function generateTimer(timer) {
      var x = 240 - (Lang.Workspace.Variable_Timer.length * 12 + 70);
      timer = timer || Entry.Variable.create({
        id: Entry.generateHash(),
        name: Lang.Workspace.Variable_Timer,
        value: 0,
        variableType: 'timer',
        visible: false,
        x: x,
        y: -70
      });
      timer.generateView();
      timer.tick = null;
      Entry.engine.projectTimer = timer;
      Entry.addEventListener('stop', function () {
        Entry.engine.stopProjectTimer();
      });
    }

    //generate Answer
  }, {
    key: "generateAnswer",
    value: function generateAnswer(answer) {
      answer = answer || Entry.Variable.create({
        id: Entry.generateHash(),
        name: Lang.Blocks.VARIABLE_get_canvas_input_value,
        value: 0,
        variableType: 'answer',
        visible: false,
        x: 150,
        y: -100
      });
      answer.generateView();
      Entry.container.inputValue = answer;
      Entry.container.inputValue.setName(Lang.Blocks.VARIABLE_get_canvas_input_value);
    }
  }, {
    key: "generateStt",
    value: function generateStt(answer) {
      answer = answer || Entry.Variable.create({
        id: Entry.generateHash(),
        name: Lang.template.voice_title_text,
        value: '-',
        variableType: 'stt',
        visible: false
      });
      answer.generateView();
      Entry.container.sttValue = answer;
    }
  }, {
    key: "generateVariableSettingView",
    value: function generateVariableSettingView(variable) {
      var that = this;
      var createElement = Entry.createElement;
      var _setFocused = Entry.Utils.setFocused;
      var _setBlurredTimer = Entry.Utils.setBlurredTimer;

      // 변수 속성 설정
      var element = createElement('div').addClass('attr_inner_box').bindOnClick(function (e) {
        return e.stopPropagation();
      });
      if (this.variableSettingView) {
        $(this.variableSettingView).remove();
        delete this.variableSettingView;
      }
      this.variableSettingView = element;
      var varAttr = createElement('div').addClass('val_attr').appendTo(element);
      var boxSubject = createElement('span').addClass('box_sjt').appendTo(varAttr);
      boxSubject.textContent = Lang.Workspace.Variable_property;
      var valTypeText = Entry.createElement('span').addClass('val_type_txt').appendTo(varAttr);
      if (variable.isRealTime_) {
        valTypeText.textContent = Lang.Menus.realtime;
      } else if (variable.isCloud_) {
        valTypeText.textContent = Lang.Menus.cloud;
      }

      // 기본 값 입력 창
      var attrInputBox = createElement('div').addClass('attr_inpt').appendTo(varAttr);
      if (this._isPythonMode()) {
        attrInputBox.addClass('hidden');
      }
      var attrInputLabel = createElement('label').appendTo(attrInputBox);
      attrInputLabel.setAttribute('for', 'attr_cnt');
      attrInputLabel.textContent = Lang.Workspace.variable_default_value;
      var attrInputWrapper = createElement('span').appendTo(attrInputBox).addClass('val_inptbox');
      var attrInput = createElement('input').appendTo(attrInputWrapper);
      attrInput.setAttribute('autocomplete', 'off');
      attrInput.setAttribute('type', 'text');
      attrInput.value = 0;
      attrInput.onkeypress = Entry.Utils.blurWhenEnter;
      attrInput.onfocus = _setFocused;
      attrInput.onblur = _setBlurredTimer(function () {
        var v = that.selected;
        if (!v) {
          console.error('error: not selected');
          return;
        }
        Entry["do"]('variableSetDefaultValue', v.id_, this.value);
      });
      element.initValueInput = attrInput;

      // 슬라이드 입력창
      var slideInputBox = createElement('div').addClass('slide_inpt').appendTo(varAttr);
      var slideCheckBox = createElement('div').addClass('chk_box').appendTo(slideInputBox);
      element.slideCheck = createElement('span').addClass('entryVariableAddSpaceCheckWorkspace').bindOnClick(function () {
        var v = that.selected;
        Entry["do"]('variableSetSlidable', v.id_, v.getType() === 'variable' ? 'slide' : 'variable');
      }).appendTo(slideCheckBox);
      var slideCheckText = createElement('span').addClass('chk_text').appendTo(slideCheckBox);
      slideCheckText.textContent = Lang.Workspace.slide;

      // 최소 최대 영역
      var slideCountBox = createElement('div').addClass('cnt_box').appendTo(slideInputBox);
      var minValueInput = createElement('input').appendTo(slideCountBox);
      minValueInput.textContent = Lang.Workspace.min_value;
      minValueInput.setAttribute('autocomplete', 'off');
      minValueInput.setAttribute('type', 'text');
      var v = that.selected;
      var vType = _.result(v, 'type');
      if (vType === 'slide') {
        minValueInput.value = v.minValue_;
      } else {
        minValueInput.value = 0;
      }
      minValueInput.onkeypress = Entry.Utils.blurWhenEnter;
      minValueInput.onfocus = _setFocused;
      minValueInput.onblur = _setBlurredTimer(function () {
        var v = that.selected;
        var value = this.value;
        value = Entry.Utils.isNumber(value) ? value : v.getMinValue();
        Entry["do"]('variableSetMinValue', v.id_, value);
      });
      element.minValueInput = minValueInput;
      createElement('span').addClass('dash').appendTo(slideCountBox).textContent = '~';
      var maxValueInput = createElement('input').appendTo(slideCountBox);
      maxValueInput.textContent = Lang.Workspace.max_value;
      maxValueInput.setAttribute('type', 'text');
      maxValueInput.setAttribute('autocomplete', 'off');
      if (vType === 'slide') {
        maxValueInput.value = v.maxValue_;
      } else {
        maxValueInput.value = 100;
      }
      maxValueInput.onkeypress = Entry.Utils.blurWhenEnter;
      maxValueInput.onfocus = _setFocused;
      maxValueInput.onblur = _setBlurredTimer(function () {
        var v = that.selected;
        var value = this.value;
        value = Entry.Utils.isNumber(value) ? value : v.getMaxValue();
        Entry["do"]('variableSetMaxValue', v.id_, value);
      });
      element.maxValueInput = maxValueInput;
      this.renderVariableReference(variable);
    }

    /**
     * @param {object|Entry.Variable} object
     */
  }, {
    key: "updateVariableSettingView",
    value: function updateVariableSettingView(v) {
      var view = this.variableSettingView;
      if (!view) {
        return;
      }
      var initValue = view.initValueInput,
        slide = view.slideCheck,
        minValue = view.minValueInput,
        maxValue = view.maxValueInput;
      slide.removeClass('on');
      if (v.getType() === 'slide') {
        slide.addClass('on');
        minValue.removeAttribute('disabled');
        maxValue.removeAttribute('disabled');
        minValue.value = v.getMinValue();
        maxValue.value = v.getMaxValue();
      } else {
        minValue.setAttribute('disabled', 'disabled');
        maxValue.setAttribute('disabled', 'disabled');
      }
      initValue.value = v.getValue();
      v.listElement.appendChild(view);
    }

    /**
     * 속성 > 리스트 편집창 표기
     */
  }, {
    key: "generateListSettingView",
    value: function generateListSettingView(list) {
      var createElement = Entry.createElement;

      // 리스트 속성 설정
      var element = createElement('div').addClass('attr_inner_box').bindOnClick(function (e) {
        return e.stopPropagation();
      });
      if (this.listSettingView) {
        $(this.listSettingView).remove();
        delete this.listSettingView;
      }
      this.listSettingView = element;
      var listAttr = createElement('div').addClass('list_attr').appendTo(element);
      if (this._isPythonMode()) {
        listAttr.addClass('hidden');
      }
      var boxSubject = createElement('span').addClass('box_sjt').appendTo(listAttr);
      boxSubject.textContent = Lang.Workspace.list_property;
      var valTypeText = Entry.createElement('span').addClass('val_type_txt').appendTo(listAttr);
      if (list.isRealTime_) {
        valTypeText.textContent = Lang.Menus.realtime;
      } else if (list.isCloud_) {
        valTypeText.textContent = Lang.Menus.cloud;
      }
      this.generateListImportExportView(listAttr);
      this.generateListCountView(listAttr);
      this.generateListValuesView(listAttr);
      this.renderVariableReference(list);
    }
  }, {
    key: "generateListImportExportView",
    value: function generateListImportExportView(element) {
      var that = this;
      var createElement = Entry.createElement;
      var buttonBox = createElement('div').addClass('btn_box').appendTo(element);
      var buttonExport = createElement('a').addClass('btn_list').bindOnClick(function (e) {
        e.stopPropagation();
        var name_ = that.selected.name_;
        var array_ = that.selected.getArray();
        if (array_.length === 0) {
          Entry.modal.alert(Lang.Menus.nothing_to_export);
        } else {
          Entry.dispatchEvent('openExportListModal', array_, name_);
        }
      }).appendTo(buttonBox);
      buttonExport.textContent = Lang.Workspace.list_export;
      var buttonImport = createElement('a').addClass('btn_list').bindOnClick(function (e) {
        e.stopPropagation();
        Entry.dispatchEvent('openImportListModal');
      }).appendTo(buttonBox);
      buttonImport.textContent = Lang.Workspace.list_import;
    }
  }, {
    key: "generateListCountView",
    value: function generateListCountView(element) {
      var that = this;
      var createElement = Entry.createElement;
      var listCount = createElement('div').addClass('list_cnt').appendTo(element);
      var countSubject = createElement('span').addClass('cnt_sjt').appendTo(listCount);
      countSubject.textContent = Lang.Workspace.number_of_list;
      var countInputBox = createElement('div').addClass('cnt_inpt').appendTo(listCount);
      var buttonMinus = createElement('a').addClass('btn_cnt').bindOnClick(function () {
        var id_ = that.selected.id_;
        Entry["do"]('listChangeLength', id_, 'minus');
      }).appendTo(countInputBox);
      buttonMinus.href = '#';
      buttonMinus.setAttribute('tabindex', '-1');
      this.listSettingView.minus = buttonMinus;

      //List limit setting. [default value:5000, length: 4]
      var limitValue = 5000;
      var maxlength = 4;
      var countInput = createElement('input').appendTo(countInputBox);
      countInput.setAttribute('autocomplete', 'off');
      countInput.setAttribute('type', 'text');
      countInput.setAttribute('maxlength', maxlength);
      countInput.onblur = function () {
        var v = that.selected;
        var value = this.value;
        var array_ = v.getArray();
        value = Entry.Utils.isNumber(value) ? value : array_.length;
        if (value >= limitValue) {
          value = limitValue;
        }
        Entry["do"]('listChangeLength', v.id_, Number(value));
      };
      countInput.onkeypress = Entry.Utils.blurWhenEnter;
      this.listSettingView.lengthInput = countInput;
      var array_ = that.selected.getArray();
      if (array_ && array_.length > 0) {
        var currentLeng = array_.length.toString().length;
        // 리스트 카운트가 5000 일떄만 설정
        maxlength = currentLeng > maxlength ? currentLeng : maxlength;
        limitValue = array_.length > limitValue ? array_.length : limitValue;
      }
      var buttonPlus = createElement('a').addClass('btn_cnt plus').bindOnClick(function () {
        var id_ = that.selected.id_;
        var array_ = Entry.variableContainer.selected.getArray();
        var selectedLength = array_.length;
        if (selectedLength >= limitValue) {
          Entry["do"]('listChangeLength', id_, '');
        } else {
          Entry["do"]('listChangeLength', id_, 'plus');
        }
      }).appendTo(countInputBox);
      buttonPlus.href = '#';
      buttonPlus.setAttribute('tabindex', '-1');
      this.listSettingView.plus = buttonPlus;
    }
  }, {
    key: "generateListValuesView",
    value: function generateListValuesView(element) {
      var createElement = Entry.createElement;
      var countGroup = createElement('div').addClass('cnt_group').appendTo(element);
      var countLabel = createElement('div').addClass('cnt_label').appendTo(countGroup);
      countLabel.textContent = Lang.Workspace.list_default_value;
      var scrollBox = createElement('div').addClass('scroll_box').appendTo(countGroup);
      var el = new _simplebar["default"](scrollBox, {
        autoHide: false
      });
      var parent = /* html */"<ol class=\"cnt_list\">{1}</ol>";
      this.listSettingView.countGroup = countGroup;
      this.listSettingView.scrollBox = scrollBox;
      this.listSettingView.simpleBar = el;
      this.listSettingView.listValues = el.getContentElement();
      this.listSettingView.infinityScroll = new Entry.VirtualScroll(this.listSettingView.listValues, {
        dataWrapper: parent,
        itemHeight: 35,
        groupSize: 10
      });
    }
  }, {
    key: "createListValueElement",
    value: function createListValueElement(index, value) {
      var startIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return "\n        <li>\n            <span class=\"cnt\">".concat(+index + startIndex, "</span>\n            <input value=\"").concat(_xssFilters["default"].inDoubleQuotedAttr(value), "\" type=\"text\" data-index=\"").concat(index, "\"/>\n            <a class=\"del\" data-index=\"").concat(index, "\"></a>\n        </li>").trim();
    }
  }, {
    key: "updateListSettingView",
    value: function updateListSettingView(list) {
      var _this20 = this;
      var view = this.listSettingView;
      var that = this;
      if (!view) {
        return;
      }
      list = list || this.selected;
      var infinityScroll = view.infinityScroll,
        countGroup = view.countGroup,
        listValues = view.listValues,
        lengthInput = view.lengthInput,
        simpleBar = view.simpleBar,
        scrollBox = view.scrollBox;
      var arr = list.getArray() || [];
      lengthInput.value = arr.length;
      if (arr.length > 4) {
        scrollBox.addClass('on');
      } else {
        scrollBox.removeClass('on');
      }
      list.listElement.appendChild(view);
      //remove element and event bindings
      var $listValues = $(listValues);
      $listValues.empty();
      $listValues.off();
      var startIndex = Entry.getMainWS().mode === Entry.Workspace.MODE_VIMBOARD ? 0 : 1;
      if ((arr === null || arr === void 0 ? void 0 : arr.length) === 0) {
        countGroup === null || countGroup === void 0 || countGroup.addClass('entryRemove');
        return;
      }
      countGroup === null || countGroup === void 0 || countGroup.removeClass('entryRemove');
      if (arr.length) {
        var data = arr.map(function (data, i) {
          var item = (data === null || data === void 0 ? void 0 : data.data) || '';
          var value = String(item).replace(/\$/g, '&#36;');
          return _this20.createListValueElement(i, value, startIndex);
        });
        infinityScroll.assignData(data);
        infinityScroll.show();
        $listValues.on('keyup', 'input', _.debounce(function (e) {
          var target = e.target;
          var index = target.getAttribute('data-index');
          data[index] = _this20.createListValueElement(index, target.value, startIndex);
          list.getArray()[index] = {
            data: target.value
          };
          list.updateView();
        }));
        $listValues.on('focus', 'input', Entry.Utils.setFocused);
        $listValues.on('keypress', 'input', Entry.Utils.blurWhenEnter);
        $listValues.on('click', 'a', function () {
          var index = this.getAttribute('data-index');
          arr.splice(index, 1);
          that.updateListSettingView();
        });
      }
      simpleBar.recalculate();
      list.updateView();
    }
  }, {
    key: "setListLength",
    value: function setListLength(list, value) {
      var _this21 = this;
      value = Number(value);
      var arr = this.selected.getArray();
      var times = value - arr.length;
      if (times && Entry.Utils.isNumber(value)) {
        if (times > 0) {
          _.times(times, function () {
            return _this21.selected.appendValue(0);
          });
        } else {
          arr.length = value;
        }
      }
      this.updateListSettingView();
    }
  }, {
    key: "updateViews",
    value: function updateViews() {
      [].concat((0, _toConsumableArray2["default"])(this.variables_), (0, _toConsumableArray2["default"])(this.lists_)).forEach(function (v) {
        return v.updateView();
      });
    }
  }, {
    key: "updateSelectedVariable",
    value: function updateSelectedVariable(object) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'variable';
      var objectType = _.result(object, 'type');
      if (this.selected) {
        this.selected.listElement.removeClass('unfold');
        this.selected.listElement.addClass('fold');
      }
      if (!object) {
        if (type === 'variable') {
          this.selected = null;
        } else {
          this.selected = null;
        }
      } else if (objectType === 'variable' || objectType === 'slide') {
        this.selected = object;
        this.selected.listElement.removeClass('fold');
        this.selected.listElement.addClass('unfold');
        if (!this.variableSettingView) {
          this.generateVariableSettingView(object);
        }
        this.updateVariableSettingView(object);
      } else if (objectType === 'list') {
        this.selected = object;
        this.selected.listElement.removeClass('fold');
        this.selected.listElement.addClass('unfold');
        if (!this.listSettingView) {
          this.generateListSettingView(object);
        }
        this.updateListSettingView(object);
      }
    }
  }, {
    key: "removeLocalVariables",
    value: function removeLocalVariables(objectId) {
      var _this22 = this;
      if (!objectId) {
        return;
      }
      (0, _toConsumableArray2["default"])(this.variables_).forEach(function (v) {
        if (v.object_ == objectId) {
          _this22.removeVariable(v);
        }
      });
    }
  }, {
    key: "addRef",
    value: function addRef(type, blockData) {
      var wsMode = _.result(Entry.getMainWS(), 'getMode');
      if (!this.view_ || wsMode !== Entry.Workspace.MODE_BOARD) {
        return;
      }
      var datum = {
        object: blockData.getCode().object,
        block: blockData
      };
      this[type].push(datum);
      Entry.playground.viewMode_ !== 'default' && this.updateList();
      return datum;
    }
  }, {
    key: "removeRef",
    value: function removeRef(type, block) {
      if (!Entry.playground.mainWorkspace) {
        return;
      }
      var wsMode = Entry.getMainWS().getMode();
      if (wsMode !== Entry.Workspace.MODE_BOARD) {
        return;
      }
      var arr = this[type];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].block == block) {
          arr.splice(i, 1);
          break;
        }
      }
      Entry.playground.viewMode_ !== 'default' && this.updateList();
    }
  }, {
    key: "updateSelected",
    value: function updateSelected() {
      if (this.selected) {
        var selected = this.selected;
        this.selected = null;
        this.select(selected);
      }
    }
  }, {
    key: "getObjectVariables",
    value: function getObjectVariables(blockList, keys) {
      var _this23 = this;
      var findFuncKeys = keys || {};
      var functions = [];
      var jsonData = this.getVariableJSONByBlockList(blockList);
      var variables = jsonData.variables;
      var messages = jsonData.messages;
      blockList.forEach(function (block) {
        var type = block.type;
        if (type && type.indexOf('func_') === 0) {
          var id = type.substr(5);
          if (!findFuncKeys[id]) {
            var func = _this23.functions_[id];
            findFuncKeys[id] = true;
            functions.push({
              id: id,
              content: JSON.stringify(func.content.toJSON()),
              type: func.type,
              localVariables: func.localVariables,
              useLocalVariables: func.useLocalVariables
            });
            var contentBlockList = func.content.getBlockList();
            var _jsonData = _this23.getObjectVariables(contentBlockList, findFuncKeys);
            functions = _.unionBy(functions, _jsonData.functions, 'id');
            variables = _.unionBy(variables, _jsonData.variables, 'id');
            messages = _.unionBy(messages, _jsonData.messages, 'id');
          }
        }
      });
      return {
        functions: functions,
        variables: variables,
        messages: messages
      };
    }
  }, {
    key: "getVariableJSONByBlockList",
    value: function getVariableJSONByBlockList(blockList) {
      var variables = [];
      var messages = [];
      var variableSet = [].concat((0, _toConsumableArray2["default"])(this.variables_), (0, _toConsumableArray2["default"])(this.lists_), (0, _toConsumableArray2["default"])(this.messages_)).reduce(function (acc, data) {
        acc[data.id_ || data.id] = data;
        return acc;
      }, {});
      blockList.forEach(function (block) {
        var data = block.data || {};
        var type = data.type;
        if (!type) {
          return;
        }
        var isMessage = (0, _includes2["default"])(EntryStatic.messageBlockList, type);
        var isVariable = (0, _includes2["default"])(EntryStatic.variableBlockList, type);
        if (isMessage || isVariable) {
          block.data.params.forEach(function (param) {
            if (typeof param === 'string' && !!variableSet[param]) {
              var item = variableSet[param];
              if (isVariable) {
                variables.push(item.toJSON());
              } else {
                messages.push({
                  id: item.id,
                  name: item.name
                });
              }
              variableSet[param] = undefined;
            }
          });
        }
      });
      return {
        variables: variables,
        messages: messages
      };
    }
  }, {
    key: "_getBlockMenu",
    value: function _getBlockMenu() {
      return _.result(Entry.getMainWS(), 'getBlockMenu');
    }
  }, {
    key: "_truncName",
    value: function _truncName(name, type, maxLen) {
      maxLen = maxLen || this._maxNameLength;
      if (name.length <= maxLen) {
        return name;
      }
      Entry.toast.warning(Lang.Workspace["".concat(type, "_name_auto_edited_title")], Lang.Workspace["".concat(type, "_too_long")]);
      return name.substring(0, maxLen);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.select(null);
      var _removeFunc = _.partial(_.result, _, 'remove');
      var _Entry3 = Entry,
        _Entry3$engine = _Entry3.engine,
        engine = _Entry3$engine === void 0 ? {} : _Entry3$engine,
        _Entry3$container = _Entry3.container,
        container = _Entry3$container === void 0 ? {} : _Entry3$container,
        playground = _Entry3.playground;
      [].concat((0, _toConsumableArray2["default"])(this.variables_), (0, _toConsumableArray2["default"])(this.lists_)).forEach(_removeFunc);
      _removeFunc(engine.projectTimer);
      _removeFunc(container.inputValue);
      _.each(this.functions_, this.removeFunction.bind(this));
      this.viewMode_ = 'all';
      this.variables_ = [];
      this.lists_ = [];
      this.messages_ = [];
      this.functions_ = {};
      this._variableRefs = [];
      this._messageRefs = [];
      this._functionRefs = [];
      Entry.Func.reset();
      playground.reloadPlayground();
      this.updateList();
    }
  }, {
    key: "_isPythonMode",
    value: function _isPythonMode() {
      return _.result(Entry.getMainWS(), 'isVimMode');
    }
  }, {
    key: "getDom",
    value: function getDom(query) {
      if (_.isEmpty(query)) {
        return;
      }
      query = (0, _toConsumableArray2["default"])(query);
      switch (query.shift()) {
        case 'filter':
          return this.filterElements[query.shift()];
        case 'functionAddButton':
          return this.functionAddButton_;
        case 'variableAddButton':
          return this.variableAddButton_;
        case 'listAddButton':
          return this.listAddButton_;
        case 'variableAddConfirmButton':
          return this.variableAddConfirmButton;
        case 'listAddConfirmButton':
          return this.listAddConfirmButton;
        case 'variableAddInput':
          return this.variableAddPanel.view.name;
        case 'listAddInput':
          return this.listAddPanel.view.name;
        case 'messageAddButton':
          return this.messageAddButton_;
        case 'variableSetVisibility':
          return this.variableSettingView.visibleCheck;
        case 'listSetVisibility':
          return this.listSettingView.visibleCheck;
        case 'variableSetDefaultValue':
          return this.variableSettingView.initValueInput;
        case 'slideCheck':
          return this.variableSettingView.slideCheck;
        case 'variableMinValue':
          return this.variableSettingView.minValueInput;
        case 'variableMaxValue':
          return this.variableSettingView.maxValueInput;
        case 'messageList':
          return this.getMessage(query.shift()).listElement.nameField;
        case 'variableScope':
          {
            var _this$_getAddPanel$vi = this._getAddPanel('variable').view,
              globalCheck = _this$_getAddPanel$vi.globalCheck,
              localCheck = _this$_getAddPanel$vi.localCheck;
            return query.shift() === 'global' ? globalCheck : localCheck;
          }
        case 'listScope':
          {
            var _this$_getAddPanel$vi2 = this._getAddPanel('list').view,
              _globalCheck = _this$_getAddPanel$vi2.globalCheck,
              _localCheck = _this$_getAddPanel$vi2.localCheck;
            return query.shift() === 'global' ? _globalCheck : _localCheck;
          }
        case 'variableCloud':
          return this._getAddPanel('variable').view.cloudCheck;
        case 'listCloud':
          return this._getAddPanel('list').view.cloudCheck;
        case 'listChangeLength':
          return this.listSettingView[query.shift()];
        case 'listDefaultValue':
          return $('.entryListSettingEachInputWorkspace')[query.shift()];
        case 'messageEditButton':
          return $(this.getMessage(query.shift()).listElement).find('.editButton')[0];
        case 'variableEditButton':
          return $(this.getVariable(query.shift()).listElement).find('.entryVariableListElementEditWorkspace')[0];
        case 'listEditButton':
          return $(this.getList(query.shift()).listElement).find('.entryVariableListElementEditWorkspace')[0];
        case 'variableName':
          return this.getVariable(query.shift()).listElement.nameField;
      }
    }
  }, {
    key: "_clickAddButton",
    value: function _clickAddButton(type, forceOpen, doNotFocus) {
      var panel = this._getAddPanel(type);
      var panelView = panel.view;
      var panelViewName = panelView.name;
      if (panel.isOpen && !forceOpen) {
        panelView.addClass('off');
        panel.isOpen = false;
      } else {
        panelViewName.value = '';
        panelView.removeClass('off');
        !doNotFocus && Entry.Utils.focusIfNotActive(panelViewName);
        panel.isOpen = true;
      }
    }
  }, {
    key: "clickVariableAddButton",
    value: function clickVariableAddButton() {
      var _this$_clickAddButton;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$_clickAddButton = this._clickAddButton).call.apply(_this$_clickAddButton, [this, 'variable'].concat(args));
      this.variableAddPanel.view.cloudCheck.addClass('on');
    }
  }, {
    key: "clickListAddButton",
    value: function clickListAddButton() {
      var _this$_clickAddButton2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_this$_clickAddButton2 = this._clickAddButton).call.apply(_this$_clickAddButton2, [this, 'list'].concat(args));
      this.listAddPanel.view.cloudCheck.addClass('on');
    }
  }, {
    key: "clickMessageAddButton",
    value: function clickMessageAddButton() {
      var _this$_clickAddButton3;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_this$_clickAddButton3 = this._clickAddButton).call.apply(_this$_clickAddButton3, [this, 'message'].concat(args));
    }
  }, {
    key: "_makeVariableData",
    value: function _makeVariableData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'variable';
      var _this$_getAddPanel2 = this._getAddPanel(type),
        view = _this$_getAddPanel2.view,
        _this$_getAddPanel2$i = _this$_getAddPanel2.info,
        isCloud = _this$_getAddPanel2$i.isCloud,
        object = _this$_getAddPanel2$i.object,
        isRealTime = _this$_getAddPanel2$i.isRealTime;
      var name = view.name.value.trim();
      if (_.isEmpty(name)) {
        name = Lang.Workspace[type];
      }
      name = this._truncName(name, type, this._maxNameLength);
      var target = "".concat(type, "s_");
      if (this.checkAllVariableName(name, target)) {
        name = Entry.getOrderedName(name, this[target], 'name_');
        Entry.toast.warning(Lang.Workspace["".concat(type, "_rename")], Lang.Workspace["".concat(type, "_dup")]);
      }
      return {
        name: name,
        isCloud: isCloud,
        isRealTime: isRealTime,
        object: object,
        variableType: type
      };
    }
  }, {
    key: "applyOption",
    value: function applyOption() {
      var _this$_filterTabs = this._filterTabs,
        variable = _this$_filterTabs.variable,
        message = _this$_filterTabs.message,
        list = _this$_filterTabs.list,
        func = _this$_filterTabs.func;
      process(variable, Entry.variableEnable);
      process(message, Entry.messageEnable);
      process(list, Entry.listEnable);
      process(func, Entry.functionEnable);
      function process(view, value) {
        if (value) {
          view.removeClass('disable');
        } else {
          view.addClass('disable');
        }
        view.disabled = !value;
      }
    }
  }, {
    key: "setVariableSlidable",
    value: function setVariableSlidable(v, type, value) {
      //no type changed
      //just return
      if (v.getType() === type) {
        return;
      }
      var variables = this.variables_;
      var variableJSON = v.toJSON();
      variableJSON.variableType = type;
      var newVariable = Entry.Variable.create(variableJSON);
      variables.splice(variables.indexOf(v), 0, newVariable);
      if (value !== undefined) {
        variableJSON.value = value;
      }
      if (type === 'slide') {
        if (newVariable.getValue() < 0) {
          newVariable.setValue(0);
        } else if (newVariable.getValue() > 100) {
          newVariable.setValue(100);
        }
      }
      this.createVariableView(newVariable);
      this.removeVariable(v);
      this.updateSelectedVariable(newVariable);
      newVariable.generateView();
    }
  }, {
    key: "_getAddPanel",
    value: function _getAddPanel() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'variable';
      return this["".concat(type, "AddPanel")];
    }
  }, {
    key: "getFunctionByBlockId",
    value: function getFunctionByBlockId(blockId) {
      return (0, _find2["default"])(this.functions_, function (func) {
        return func.getBlockById(blockId);
      });
    }
  }]);
}());
function _removeChildrenClass(_ref14, className) {
  var children = _ref14.children;
  for (var index in children) {
    var dom = children[index];
    if (dom.removeClass) {
      dom.removeClass(className);
    }
  }
}